import me, { produce as Pt } from "immer";
import ut, { useReducer as H, useCallback as R, useEffect as b, createContext as pt, useRef as _e, useMemo as de, useState as oe } from "react";
import { Status as i } from "@prometheus/types";
import { parseFiltersToStringParams as It, keyBy as vt, formatFilterListNoFiql as wt, getReducerWithProduce as Ae, convertListToHashMap as Gt, getNumberUUID as Ft, collectIds as At, getNumberUUIDWidthLimit as ze, getSortDirection as Rt, api as K, convertVersionListDTOToVersionList as kt, parseActions as Qe, isEqual as Te, checkFormatDateSave as Xe, generateAlias as ft } from "@prometheus/utils";
import { Modal as Yt, ModalTitle as Vt, useNotifications as yt } from "@prometheus/components";
import { MetaAttributeTypes as fe, AnalysisTypes as w, DateFormat as Je, TypesOfContainer as Ke, EntityTypes as Mt, FileExtension as Ze, mapStandardConceptTypes as Qt } from "@prometheus/enums";
var k = /* @__PURE__ */ ((e) => (e.FETCH_REQUEST = "FETCH_REQUEST", e.FETCH_REQUEST_DONE = "FETCH_REQUEST_DONE", e.FETCH_REQUEST_FAILED = "FETCH_REQUEST_FAILED", e.REMOVE_REQUEST = "REMOVE_REQUEST", e.REMOVE_REQUEST_DONE = "REMOVE_REQUEST_DONE", e.REMOVE_REQUEST_FAILED = "REMOVE_REQUEST_FAILED", e.SET_COUNT = "SET_COUNT", e.SET_SIZE = "SET_SIZE", e.SET_QUERY = "SET_QUERY", e.SET_SORT = "SET_SORT", e.SET_NUMBER = "SET_NUMBER", e.SET_LIST_SORTING = "SET_LIST_SORTING", e.UPDATE_FILTERS = "UPDATE_FILTERS", e.RESET_STATE = "RESET_STATE", e))(k || {});
const Ye = {
  data: { tableData: [], filtersData: [] },
  pageCount: 1,
  pageSize: 15,
  isLoading: !1,
  isReloadLoading: !1,
  pageNumber: 0,
  sort: null,
  totalElements: 0,
  numberOfElements: 0,
  actions: null,
  allowedSorting: [],
  filters: {},
  status: i.INITIAL,
  error: null
}, xt = (e, o) => me(e, (t) => {
  var s;
  switch (o.type) {
    case k.FETCH_REQUEST:
      t.status = t.status === i.INITIAL ? i.IN_PROGRESS : i.IN_PROGRESS_RELOAD;
      break;
    case k.FETCH_REQUEST_DONE:
      t.data.tableData = o.payload.content || o.payload, t.data.filtersData = o.payload.filters, t.actions = o.payload.actions, t.pageCount = o.payload.totalPages || 1, t.pageNumber = ((s = o.payload.pageable) == null ? void 0 : s.pageNumber) || 0, t.numberOfElements = o.payload.numberOfElements, t.totalElements = o.payload.totalElements, t.sort = o.payload.sort, t.status = i.SUCCESS;
      break;
    case k.UPDATE_FILTERS:
      t.filters = {
        ...t.filters,
        ...o.payload
      };
      break;
    case k.FETCH_REQUEST_FAILED:
      t.data.tableData = [], t.actions = [], t.error = o.payload, t.status = i.ERROR;
      break;
    case k.SET_COUNT:
      t.pageCount = o.payload;
      break;
    case k.SET_SIZE:
      t.pageSize = o.payload;
      break;
    case k.SET_NUMBER:
      t.pageNumber = o.payload;
      break;
    case k.REMOVE_REQUEST:
      break;
    case k.REMOVE_REQUEST_DONE:
      break;
    case k.REMOVE_REQUEST_FAILED:
      break;
    case k.SET_LIST_SORTING:
      t.allowedSorting = o.payload;
      break;
    case k.RESET_STATE:
      t.data.tableData = [], t.data.filtersData = [], t.filters = {}, t.actions = [], t.pageCount = 1, t.pageNumber = 0, t.numberOfElements = 0, t.totalElements = 0, t.sort = {}, t.status = i.INITIAL;
      break;
  }
}), Is = (e, o, t, s) => {
  const [r, E] = H(xt, {
    ...Ye,
    filters: (s == null ? void 0 : s.filters) || Ye.filters,
    pageSize: (s == null ? void 0 : s.pageSize) || Ye.pageSize,
    sort: (s == null ? void 0 : s.sort) || Ye.sort
  }), a = R(
    async (O, N, L, A = !1) => {
      var U;
      A || E({
        type: k.FETCH_REQUEST,
        payload: t && o
      });
      try {
        const P = It(r.filters), x = await e.get(
          O,
          N,
          L,
          P
        );
        if (A) return vt(x.content || x, "id");
        const Y = await ((U = e.getFilters) == null ? void 0 : U.call(e, P).then(wt)) || [];
        E({
          type: k.FETCH_REQUEST_DONE,
          payload: {
            ...x,
            reload: t && o,
            filters: Y,
            sort: L
          }
        });
      } catch (P) {
        console.error("ERROR", P), E({
          type: k.FETCH_REQUEST_FAILED,
          payload: P
        });
      }
    },
    [e.get, r.filters, o]
  ), c = R(
    async (O) => {
      E({
        type: k.REMOVE_REQUEST,
        payload: O
      });
      try {
        return await e.remove(O), await a(r.pageNumber, r.pageSize, r.sort), E({
          type: k.REMOVE_REQUEST_DONE,
          payload: O
        }), !0;
      } catch (N) {
        return E({
          type: k.REMOVE_REQUEST_FAILED,
          payload: {
            err: N
          }
        }), !1;
      }
    },
    [e.remove, r.pageNumber, r.pageSize, r.sort]
  ), S = R(
    (O) => {
      E({
        type: k.UPDATE_FILTERS,
        payload: O
      });
    },
    [r.filters]
  ), u = R((O) => {
    E({
      type: k.SET_COUNT,
      payload: O
    });
  }, []), _ = R((O) => {
    E({
      type: k.SET_NUMBER,
      payload: O
    });
  }, []), l = (O) => {
    E({
      type: k.SET_SIZE,
      payload: O
    });
  }, I = R((O) => {
    E({
      type: k.SET_QUERY,
      payload: O
    });
  }, []), T = R(async () => {
    if (e != null && e.getSorting)
      try {
        const O = await e.getSorting();
        E({
          type: k.SET_LIST_SORTING,
          payload: O
        });
      } catch {
        console.error("GET LIST SORTING: sth went wrong");
      }
  }, []), y = () => {
    E({ type: k.RESET_STATE });
  };
  return b(() => {
    T();
  }, [T]), {
    ...r,
    getEntity: a,
    removeEntity: c,
    setPageCount: u,
    setPageNumber: _,
    setPageSize: l,
    setQuery: I,
    updateFilters: S,
    resetState: y
  };
};
var je = { exports: {} }, ve = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var et;
function $t() {
  if (et) return ve;
  et = 1;
  var e = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function t(s, r, E) {
    var a = null;
    if (E !== void 0 && (a = "" + E), r.key !== void 0 && (a = "" + r.key), "key" in r) {
      E = {};
      for (var c in r)
        c !== "key" && (E[c] = r[c]);
    } else E = r;
    return r = E.ref, {
      $$typeof: e,
      type: s,
      key: a,
      ref: r !== void 0 ? r : null,
      props: E
    };
  }
  return ve.Fragment = o, ve.jsx = t, ve.jsxs = t, ve;
}
var we = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tt;
function jt() {
  return tt || (tt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(n) {
      if (n == null) return null;
      if (typeof n == "function")
        return n.$$typeof === be ? null : n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case O:
          return "Fragment";
        case L:
          return "Profiler";
        case N:
          return "StrictMode";
        case x:
          return "Suspense";
        case Y:
          return "SuspenseList";
        case $:
          return "Activity";
      }
      if (typeof n == "object")
        switch (typeof n.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), n.$$typeof) {
          case y:
            return "Portal";
          case U:
            return (n.displayName || "Context") + ".Provider";
          case A:
            return (n._context.displayName || "Context") + ".Consumer";
          case P:
            var d = n.render;
            return n = n.displayName, n || (n = d.displayName || d.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
          case Q:
            return d = n.displayName || null, d !== null ? d : e(n.type) || "Memo";
          case se:
            d = n._payload, n = n._init;
            try {
              return e(n(d));
            } catch {
            }
        }
      return null;
    }
    function o(n) {
      return "" + n;
    }
    function t(n) {
      try {
        o(n);
        var d = !1;
      } catch {
        d = !0;
      }
      if (d) {
        d = console;
        var m = d.error, g = typeof Symbol == "function" && Symbol.toStringTag && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return m.call(
          d,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          g
        ), o(n);
      }
    }
    function s(n) {
      if (n === O) return "<>";
      if (typeof n == "object" && n !== null && n.$$typeof === se)
        return "<...>";
      try {
        var d = e(n);
        return d ? "<" + d + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var n = Re.A;
      return n === null ? null : n.getOwner();
    }
    function E() {
      return Error("react-stack-top-frame");
    }
    function a(n) {
      if (V.call(n, "key")) {
        var d = Object.getOwnPropertyDescriptor(n, "key").get;
        if (d && d.isReactWarning) return !1;
      }
      return n.key !== void 0;
    }
    function c(n, d) {
      function m() {
        ye || (ye = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          d
        ));
      }
      m.isReactWarning = !0, Object.defineProperty(n, "key", {
        get: m,
        configurable: !0
      });
    }
    function S() {
      var n = e(this.type);
      return D[n] || (D[n] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), n = this.props.ref, n !== void 0 ? n : null;
    }
    function u(n, d, m, g, f, v, Ee, ne) {
      return m = v.ref, n = {
        $$typeof: T,
        type: n,
        key: d,
        props: v,
        _owner: f
      }, (m !== void 0 ? m : null) !== null ? Object.defineProperty(n, "ref", {
        enumerable: !1,
        get: S
      }) : Object.defineProperty(n, "ref", { enumerable: !1, value: null }), n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(n, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(n, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ee
      }), Object.defineProperty(n, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    }
    function _(n, d, m, g, f, v, Ee, ne) {
      var G = d.children;
      if (G !== void 0)
        if (g)
          if (W(G)) {
            for (g = 0; g < G.length; g++)
              l(G[g]);
            Object.freeze && Object.freeze(G);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else l(G);
      if (V.call(d, "key")) {
        G = e(n);
        var q = Object.keys(d).filter(function(z) {
          return z !== "key";
        });
        g = 0 < q.length ? "{key: someKey, " + q.join(": ..., ") + ": ...}" : "{key: someKey}", h[G + g] || (q = 0 < q.length ? "{" + q.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          g,
          G,
          q,
          G
        ), h[G + g] = !0);
      }
      if (G = null, m !== void 0 && (t(m), G = "" + m), a(d) && (t(d.key), G = "" + d.key), "key" in d) {
        m = {};
        for (var ie in d)
          ie !== "key" && (m[ie] = d[ie]);
      } else m = d;
      return G && c(
        m,
        typeof n == "function" ? n.displayName || n.name || "Unknown" : n
      ), u(
        n,
        G,
        v,
        f,
        r(),
        m,
        Ee,
        ne
      );
    }
    function l(n) {
      typeof n == "object" && n !== null && n.$$typeof === T && n._store && (n._store.validated = 1);
    }
    var I = ut, T = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), O = Symbol.for("react.fragment"), N = Symbol.for("react.strict_mode"), L = Symbol.for("react.profiler"), A = Symbol.for("react.consumer"), U = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), Y = Symbol.for("react.suspense_list"), Q = Symbol.for("react.memo"), se = Symbol.for("react.lazy"), $ = Symbol.for("react.activity"), be = Symbol.for("react.client.reference"), Re = I.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, V = Object.prototype.hasOwnProperty, W = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    I = {
      react_stack_bottom_frame: function(n) {
        return n();
      }
    };
    var ye, D = {}, p = I.react_stack_bottom_frame.bind(
      I,
      E
    )(), C = M(s(E)), h = {};
    we.Fragment = O, we.jsx = function(n, d, m, g, f) {
      var v = 1e4 > Re.recentlyCreatedOwnerStacks++;
      return _(
        n,
        d,
        m,
        !1,
        g,
        f,
        v ? Error("react-stack-top-frame") : p,
        v ? M(s(n)) : C
      );
    }, we.jsxs = function(n, d, m, g, f) {
      var v = 1e4 > Re.recentlyCreatedOwnerStacks++;
      return _(
        n,
        d,
        m,
        !0,
        g,
        f,
        v ? Error("react-stack-top-frame") : p,
        v ? M(s(n)) : C
      );
    };
  }()), we;
}
process.env.NODE_ENV === "production" ? je.exports = $t() : je.exports = jt();
var ce = je.exports, Ce = /* @__PURE__ */ ((e) => (e.SET_COMPONENT = "SET_COMPONENT", e.SHOW_DIALOG = "SHOW_DIALOG", e.HIDE_DIALOG = "HIDE_DIALOG", e.DESTROY_DIALOG = "DESTROY_DIALOG", e))(Ce || {});
const Bt = (e, o) => me(e, (t) => {
  switch (o.type) {
    case Ce.SET_COMPONENT: {
      t.component = o.payload;
      break;
    }
    case Ce.SHOW_DIALOG: {
      t.components.push({
        component: o.payload.component,
        props: { ...o.payload.props, open: !0 }
      }), t.component = o.payload.component, t.props = { ...o.payload.props, open: !0 };
      break;
    }
    case Ce.HIDE_DIALOG: {
      t.components.shift(), t.props = { ...t.props, open: !1 };
      break;
    }
    case Ce.DESTROY_DIALOG: {
      t.component = null, t.props = {};
      break;
    }
  }
}), Ht = {
  components: [],
  component: null,
  props: {}
}, Wt = () => {
  const [e, o] = H(Bt, Ht), t = (E, a) => {
    o({
      type: Ce.SHOW_DIALOG,
      payload: { component: E, props: a }
    });
  }, s = () => {
    o({
      type: Ce.HIDE_DIALOG
    });
  }, r = R(() => {
    o({
      type: Ce.DESTROY_DIALOG
    });
  }, []);
  return {
    ...e,
    dialogCount: e.components.length,
    hideDialog: s,
    showDialog: t,
    destroyDialog: r
  };
}, Ot = "__prometheusOverlayHistory", ot = {
  modal: 0,
  dialog: 0
}, Be = (e) => typeof e == "object" && e !== null, st = (e) => typeof e != "number" || !Number.isFinite(e) || e <= 0 ? 0 : Math.floor(e), dt = (e = window.history.state) => {
  if (!Be(e))
    return ot;
  const o = e[Ot];
  return Be(o) ? {
    modal: st(o.modal),
    dialog: st(o.dialog)
  } : ot;
}, ge = (e, o = window.history.state) => dt(o)[e], Ct = (e, o) => {
  const t = Be(window.history.state) ? window.history.state : {}, s = {
    ...dt(window.history.state),
    [e]: o
  };
  window.history.pushState(
    {
      ...t,
      [Ot]: s
    },
    "",
    window.location.href
  );
}, qt = pt(null), As = ({
  // initialComponent,
  children: e
}) => {
  const {
    // component,
    components: o,
    dialogCount: t,
    // props,
    showDialog: s,
    hideDialog: r,
    destroyDialog: E
  } = Wt(), a = _e(t), c = _e(t);
  b(() => {
    a.current = t;
  }, [t]), b(() => {
    const I = (T) => {
      const y = a.current, O = ge("dialog", T.state);
      if (O < y)
        for (let N = 0; N < y - O; N++)
          r();
    };
    return window.addEventListener("popstate", I), () => {
      window.removeEventListener("popstate", I);
    };
  }, [r]), b(() => {
    const I = c.current;
    if (t > I)
      for (let T = I + 1; T <= t; T++)
        Ct("dialog", T);
    c.current = t;
  }, [t]);
  const S = R(() => {
    const I = a.current;
    if (!I)
      return;
    a.current = I - 1, c.current = I - 1, r(), ge("dialog") >= I && window.history.back();
  }, [r]), u = R(() => {
    const I = a.current;
    if (!I) {
      E();
      return;
    }
    a.current = 0, c.current = 0, E(), ge("dialog") >= I && window.history.go(-I);
  }, [E]), _ = de(
    () => ({
      showDialog: s,
      hideDialog: S,
      destroyDialog: u
    }),
    [u, S, s]
  ), l = () => o.map((I, T) => {
    const y = I.component;
    return y ? /* @__PURE__ */ ce.jsx(y, { ...I.props }, T + "-dialog") : /* @__PURE__ */ ce.jsx(ce.Fragment, {});
  });
  return /* @__PURE__ */ ce.jsxs(qt.Provider, { value: _, children: [
    e,
    l()
  ] });
}, Nt = {
  form: {},
  data: null,
  getFilters: void 0,
  formatFilters: void 0,
  status: i.INITIAL,
  reloadStatus: i.INITIAL
};
var ee = /* @__PURE__ */ ((e) => (e.SET_FILTER_PANEL = "SET_FILTER_PANEL", e.SET_FILTER_PANEL_DATA = "SET_FILTER_PANEL_DATA", e.RESET_FILTER_PANEL = "RESET_FILTER_PANEL", e.SET_FILTER_PANEL_STATUS = "SET_FILTER_PANEL_STATUS", e.UPDATE_FILTER_PANEL = "UPDATE_FILTER_PANEL", e.UPDATE_FILTER_PANEL_ALL = "UPDATE_FILTER_PANEL_ALL", e.GET_FILTER_PANEL_DATA = "GET_FILTER_PANEL_DATA", e))(ee || {});
const zt = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case ee.SET_FILTER_PANEL: {
      t.getFilters = o.payload.getFilters, t.formatFilters = o.payload.formatFilters, t.filterReqBody = o.payload.filterReqBody, o.payload.filterReqBody && Object.keys(o.payload.filterReqBody).forEach((s) => {
        t.form[s] = o.payload.filterReqBody[s];
      });
      break;
    }
    case ee.GET_FILTER_PANEL_DATA: {
      t.status === i.INITIAL ? t.status = i.IN_PROGRESS : t.reloadStatus = i.IN_PROGRESS;
      break;
    }
    case ee.SET_FILTER_PANEL_DATA: {
      t.data = o.payload, t.reloadStatus = i.SUCCESS, t.status = i.SUCCESS;
      break;
    }
    case ee.SET_FILTER_PANEL_STATUS: {
      t.status = o.payload;
      break;
    }
    case ee.UPDATE_FILTER_PANEL: {
      const { key: s, value: r } = o.payload;
      t.form[s] = r, t.status = i.SUCCESS;
      break;
    }
    case ee.UPDATE_FILTER_PANEL_ALL: {
      t.form = o.payload;
      break;
    }
    case ee.RESET_FILTER_PANEL:
      return { ...t, ...Nt };
  }
}), Rs = (e) => {
  const [o, t] = H(
    zt,
    Nt
  ), s = R((u) => {
    t({
      type: ee.SET_FILTER_PANEL_STATUS,
      payload: u
    });
  }, []), r = R(() => {
    t({ type: ee.RESET_FILTER_PANEL });
  }, []), E = R(
    async (u, _, l = {}) => {
      if (u)
        try {
          t({
            type: ee.SET_FILTER_PANEL,
            payload: {
              getFilters: u,
              formatFilters: _,
              filterReqBody: l
            }
          });
        } catch {
          s(i.ERROR);
        }
    },
    []
  ), a = R(
    async (u) => {
      t({ type: ee.GET_FILTER_PANEL_DATA });
      try {
        const _ = It(u);
        if (e) {
          const l = await (e == null ? void 0 : e.get(_, o.filterReqBody)), I = e != null && e.format ? e.format(l) : l;
          t({
            type: ee.SET_FILTER_PANEL_DATA,
            payload: I
          });
        } else {
          const l = await o.getFilters(_, o.filterReqBody), I = o.formatFilters ? o.formatFilters(l) : l;
          t({
            type: ee.SET_FILTER_PANEL_DATA,
            payload: I
          });
        }
      } catch {
        s(i.ERROR);
      }
    },
    [o.getFilters]
  ), c = R((u, _) => {
    u && t({
      type: ee.UPDATE_FILTER_PANEL,
      payload: { key: u, value: _ }
    });
  }, []), S = R((u) => {
    t({
      type: ee.UPDATE_FILTER_PANEL_ALL,
      payload: u
    });
  }, []);
  return b(() => {
    const { getFilters: u } = o;
    (u || e != null && e.get) && a(o.form);
  }, [a, o.form]), {
    ...o,
    setFiltersStatus: s,
    setFilters: E,
    updateFilters: c,
    resetFilters: r,
    updateAllFilters: S
  };
};
var F = /* @__PURE__ */ ((e) => (e.GET_ENTITY_LIST_PENDING = "GET_ENTITY_LIST_PENDING", e.GET_ENTITY_LIST_SUCCESS = "GET_ENTITY_LIST_SUCCESS", e.GET_ENTITY_LIST_FAILURE = "GET_ENTITY_LIST_FAILURE", e.GET_ENTITY_PENDING = "GET_ENTITY_PENDING", e.GET_ENTITY_SUCCESS = "GET_ENTITY_SUCCESS", e.GET_ENTITY_FAILURE = "GET_ENTITY_FAILURE", e.CREATE_ENTITY_PENDING = "CREATE_ENTITY_PENDING", e.CREATE_ENTITY_SUCCESS = "CREATE_ENTITY_SUCCESS", e.CREATE_ENTITY_FAILURE = "CREATE_ENTITY_FAILURE", e.UPDATE_ENTITY_PENDING = "UPDATE_ENTITY_PENDING", e.UPDATE_ENTITY_SUCCESS = "UPDATE_ENTITY_SUCCESS", e.UPDATE_ENTITY_FAILURE = "UPDATE_ENTITY_FAILURE", e.DELETE_ENTITY_PENDING = "DELETE_ENTITY_PENDING", e.DELETE_ENTITY_SUCCESS = "DELETE_ENTITY_SUCCESS", e.DELETE_ENTITY_FAILURE = "DELETE_ENTITY_FAILURE", e.GET_ALLOWED_SORTING_SUCCESS = "GET_ALLOWED_SORTING_SUCCESS", e))(F || {});
function Xt(e, o) {
  return Pt(e, (t) => {
    switch (o.type) {
      case F.GET_ENTITY_LIST_PENDING: {
        t.isError = !1, t.isLoading = !0, t.processingIds = [], t.status = t.status === i.INITIAL ? i.IN_PROGRESS : i.IN_PROGRESS_RELOAD;
        break;
      }
      case F.GET_ENTITY_LIST_SUCCESS: {
        const {
          data: s,
          primaryKey: r,
          actions: E,
          totalPages: a,
          totalElements: c,
          numberOfElements: S,
          number: u,
          size: _
        } = o.payload;
        t.ids = s.map((l) => l[r]), t.byId = Gt(s, String(r)), t.rawData = s, t.actions = E, t.isLoading = !1, t.isLoaded = !0, t.pageCount = a || 1, t.totalElements = c, t.numberOfElements = S, t.pageNumber = u || 0, t.pageSize = _ || 10, t.status = i.SUCCESS;
        break;
      }
      case F.GET_ENTITY_LIST_FAILURE: {
        t.isError = !0, t.isLoading = !1, t.isLoaded = !0, t.status = i.ERROR;
        break;
      }
      case F.GET_ENTITY_SUCCESS: {
        t.byId[o.payload.id] = o.payload.data;
        break;
      }
      case F.CREATE_ENTITY_PENDING:
        break;
      case F.CREATE_ENTITY_SUCCESS: {
        const { data: s, primaryKey: r, actions: E } = o.payload, a = s[r];
        t.isLoading = !1, t.ids.push(a), t.byId[a] = s, t.actions = E;
        break;
      }
      case F.CREATE_ENTITY_FAILURE:
        break;
      case F.DELETE_ENTITY_PENDING: {
        const { data: s, primaryKey: r } = o.payload, E = s[r];
        t.processingIds.push(E);
        break;
      }
      case F.DELETE_ENTITY_SUCCESS: {
        const { data: s, primaryKey: r } = o.payload, E = s[r];
        t.ids = t.ids.filter((a) => a !== E), t.processingIds = t.processingIds.filter(
          (a) => a !== E
        ), delete t.byId[E];
        break;
      }
      case F.DELETE_ENTITY_FAILURE:
        break;
      case F.GET_ALLOWED_SORTING_SUCCESS: {
        t.allowedSorting = o.payload.allowedSorting;
        break;
      }
    }
  });
}
const Jt = {
  isLoading: !1,
  isLoaded: !1,
  isError: !1,
  byId: {},
  ids: [],
  actions: null,
  currentlyProcessingId: null,
  processingIds: [],
  status: i.INITIAL,
  pageCount: 1,
  pageNumber: 0,
  pageSize: 5,
  numberOfElements: 0,
  totalElements: 0,
  allowedSorting: [],
  rawData: []
};
function ys(e) {
  const {
    primaryKey: o = "id",
    autoLoad: t = !1,
    async: s = !0,
    values: r = [],
    methods: E
  } = e, {
    read: a,
    get: c,
    create: S,
    update: u,
    delete: _,
    sort: l
  } = E || {}, [I, T] = H(
    Xt,
    Jt
  ), {
    isLoading: y,
    isLoaded: O,
    byId: N,
    ids: L,
    processingIds: A,
    isError: U,
    actions: P,
    status: x
  } = I, Y = R(
    async (V, W) => {
      if (!(a != null && a.method) && s)
        throw Error('"Read" method is not defined.');
      if (!s) {
        T({
          type: F.GET_ENTITY_LIST_SUCCESS,
          payload: r
        });
        return;
      }
      try {
        T({
          type: F.GET_ENTITY_LIST_PENDING
        });
        const M = await a.method(V || {}), ye = M.content || M, D = M.actions;
        T({
          type: F.GET_ENTITY_LIST_SUCCESS,
          payload: {
            data: W && typeof W == "function" ? W(ye) : a.formatter && typeof a.formatter == "function" ? a.formatter(ye) : ye,
            actions: D,
            primaryKey: o,
            ...M
          }
        });
      } catch (M) {
        T({
          type: F.GET_ENTITY_LIST_FAILURE,
          payload: {
            err: M
          }
        });
      }
    },
    [s, ...s ? [] : [r], o]
  ), Q = R(
    async (V, W = !1) => {
      if (!(S != null && S.method) && W)
        throw Error('"Create" method is not defined.');
      if (!W) {
        T({
          type: F.CREATE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        return;
      }
      try {
        T({
          type: F.CREATE_ENTITY_PENDING,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        const M = await (S == null ? void 0 : S.method(V));
        T({
          type: F.CREATE_ENTITY_SUCCESS,
          payload: {
            data: M,
            primaryKey: o
          }
        });
      } catch (M) {
        T({
          type: F.CREATE_ENTITY_FAILURE,
          payload: {
            err: M
          }
        });
      }
    },
    [o]
  ), se = R(async (V) => {
  }, []), $ = R(async (V) => {
    if (!(c != null && c.method) && s)
      throw Error('"Get" method is not defined.');
    try {
      const W = await (c == null ? void 0 : c.method(V)), M = c == null ? void 0 : c.formatter([W]);
      T({
        type: F.GET_ENTITY_SUCCESS,
        payload: {
          id: W.id,
          data: M[0]
        }
      });
    } catch {
    }
  }, []), be = R(
    async (V, W = !1) => {
      if (!(_ != null && _.method) && W)
        throw Error('"Delete" method is not defined.');
      if (!W) {
        T({
          type: F.DELETE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        return;
      }
      try {
        T({
          type: F.DELETE_ENTITY_PENDING,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        const M = await (_ == null ? void 0 : _.method(V));
        T({
          type: F.DELETE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
      } catch (M) {
        T({
          type: F.DELETE_ENTITY_FAILURE,
          payload: {
            err: M,
            data: V,
            primaryKey: o
          }
        });
      }
    },
    [o]
  ), Re = R(async () => {
    if (l)
      try {
        const V = await l.method();
        T({
          type: F.GET_ALLOWED_SORTING_SUCCESS,
          payload: {
            allowedSorting: V
          }
        });
      } catch {
        console.error("GET LIST SORTING: sth went wrong");
      }
  }, []);
  return b(() => {
    t && Y({});
  }, [t]), b(() => {
    Re();
  }, [Re]), {
    ...I,
    processingIds: A,
    data: {
      byId: N,
      ids: L
    },
    getEntityList: Y,
    createEntity: Q,
    updateEntity: se,
    removeEntity: be,
    getEntity: $
  };
}
const Kt = {
  content: null,
  props: {
    open: !1
  }
}, Zt = () => {
  const [e, o] = oe([]), t = R(
    (c, S, u) => {
      o((_) => [
        ..._,
        {
          content: c,
          title: S,
          props: { ...u, open: !0 }
        }
      ]);
    },
    []
  ), s = R(() => {
    o((c) => c.slice(0, -1));
  }, []), r = R((c) => {
    o((S) => S.slice(0, Math.max(0, S.length - c)));
  }, []), E = R(() => {
    o([]);
  }, []);
  return {
    ...e[e.length - 1] || Kt,
    modalCount: e.length,
    openModal: t,
    closeModal: s,
    closeAllModals: E,
    closeModals: r
  };
}, eo = pt({
  openModal: () => {
  },
  closeModal: () => {
  },
  closeAllModals: () => {
  }
}), Os = ({ children: e }) => {
  var N, L;
  const {
    openModal: o,
    closeModal: t,
    closeAllModals: s,
    closeModals: r,
    modalCount: E,
    ...a
  } = Zt(), c = _e(E), S = _e(E), u = (A) => {
    const U = String(A || "").trim();
    return U && (U.startsWith("/") ? U : `/${U}`).replace(/\/+$/, "") || "/";
  };
  b(() => {
    const A = () => {
      s();
    };
    return window.addEventListener("prometheus:close-modal", A), () => {
      window.removeEventListener("prometheus:close-modal", A);
    };
  }, [s]), b(() => {
    c.current = E;
  }, [E]), b(() => {
    const A = () => {
      window.dispatchEvent(new Event("prometheus:location-change"));
    }, U = (Y) => {
      const Q = c.current, se = ge("modal", Y.state);
      se < Q && r(Q - se);
    }, P = window.history.pushState, x = window.history.replaceState;
    return window.history.pushState = function(...Y) {
      const Q = P.apply(this, Y);
      return A(), Q;
    }, window.history.replaceState = function(...Y) {
      const Q = x.apply(this, Y);
      return A(), Q;
    }, window.addEventListener("popstate", U), window.addEventListener("popstate", A), () => {
      window.history.pushState = P, window.history.replaceState = x, window.removeEventListener("popstate", U), window.removeEventListener("popstate", A);
    };
  }, [r]), b(() => {
    const A = S.current;
    if (E > A)
      for (let U = A + 1; U <= E; U++)
        Ct("modal", U);
    S.current = E;
  }, [E]);
  const _ = R(() => {
    const A = c.current;
    if (!A)
      return;
    c.current = A - 1, S.current = A - 1, t(), ge("modal") >= A && window.history.back();
  }, [t]), l = R(() => {
    const A = c.current;
    if (!A)
      return;
    c.current = 0, S.current = 0, s(), ge("modal") >= A && window.history.go(-A);
  }, [s]), I = de(
    () => ({
      openModal: o,
      closeModal: _,
      closeAllModals: l
    }),
    [l, _, o]
  );
  b(() => {
    const A = () => {
      var Q, se;
      const U = (Q = a == null ? void 0 : a.props) == null ? void 0 : Q.closeOnRouteChangeOutside;
      if (!((se = a == null ? void 0 : a.props) != null && se.open) || !U)
        return;
      const P = u(window.location.pathname);
      (Array.isArray(U) ? U : [U]).map(($) => u($)).filter(Boolean).some(($) => P === $ || P.startsWith(`${$}/`)) || l();
    };
    return A(), window.addEventListener("prometheus:location-change", A), () => {
      window.removeEventListener(
        "prometheus:location-change",
        A
      );
    };
  }, [
    l,
    (N = a == null ? void 0 : a.props) == null ? void 0 : N.closeOnRouteChangeOutside,
    (L = a == null ? void 0 : a.props) == null ? void 0 : L.open
  ]);
  const T = (...A) => {
    if (a.props.onClose) {
      a.props.onClose(...A);
      return;
    }
    _();
  }, y = typeof a.props.width == "number" ? `${a.props.width}px` : a.props.width, O = () => {
    const A = a;
    if (A) {
      const { content: U, title: P } = A;
      return U ? /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
        P && /* @__PURE__ */ ce.jsx(Vt, { onClose: T, children: P }),
        /* @__PURE__ */ ce.jsx(U, {})
      ] }) : /* @__PURE__ */ ce.jsx(ce.Fragment, {});
    }
  };
  return /* @__PURE__ */ ce.jsx("div", { children: /* @__PURE__ */ ce.jsxs(eo.Provider, { value: I, children: [
    e,
    /* @__PURE__ */ ce.jsx(
      Yt,
      {
        open: a.props.open,
        onClose: T,
        closeOnClickOutside: a.props.closeOnClickOutside,
        collapsible: a.props.collapsible,
        width: y,
        children: O()
      }
    )
  ] }) });
};
var De = /* @__PURE__ */ ((e) => (e.GET_STUDY_TYPE = "GET_STUDY_TYPE", e.SET_STUDY_TYPE_SUCCESS = "SET_STUDY_TYPE_SUCCESS", e.SET_STUDY_TYPE_ERROR = "SET_STUDY_TYPE_ERROR", e))(De || {});
const to = {
  studyTypes: {
    isLoading: !1,
    data: [],
    error: null
  }
}, oo = (e, o) => me(e, (t) => {
  switch (o.type) {
    case De.GET_STUDY_TYPE:
      t.isLoading = !0, t.error = null;
      break;
    case De.SET_STUDY_TYPE_SUCCESS:
      t.isLoading = !1, t.studyTypes.data = o.payload;
      break;
    case De.SET_STUDY_TYPE_ERROR:
      t.isLoading = !1, t.error = o.payload;
      break;
  }
}), ds = (e) => {
  const [o, t] = H(oo, to), s = R(async () => {
    t({
      type: De.GET_STUDY_TYPE
    });
    try {
      const r = await e();
      t({
        type: De.SET_STUDY_TYPE_SUCCESS,
        payload: r.content
      });
    } catch (r) {
      console.error("STUDY TYPES ERROR", r), t({
        type: De.SET_STUDY_TYPE_ERROR,
        payload: r
      });
    }
  }, []);
  return {
    ...o,
    getTypesOfStudy: s
  };
}, Cs = ut.createContext({});
var pe = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_SECTION = "ADD_SECTION", e.COPY_SECTION = "COPY_SECTION", e.REMOVE_SECTION = "REMOVE_SECTION", e.UPDATE_SECTION = "UPDATE_SECTION", e))(pe || {});
const so = (e, o) => me(e, (t) => {
  switch (o.type) {
    case pe.INIT:
      t.sections = o.payload, t.status = i.SUCCESS, t.isStartHook = !0;
      break;
    case pe.ADD_SECTION:
      t.sections = t.sections.map((s) => ({
        ...s,
        defaultState: !1
      })), t.sections.push({ ...o.payload, defaultState: !0 });
      break;
    case pe.COPY_SECTION:
      t.sections = t.sections.map((s) => ({
        ...s,
        defaultState: !1
      })), t.sections.splice(o.payload.id, 0, {
        ...o.payload.section,
        defaultState: !0
      });
      break;
    case pe.UPDATE_SECTION:
      o.payload.id >= 0 && t.sections.splice(o.payload.id, 1, o.payload.section);
      break;
    case pe.REMOVE_SECTION:
      t.sections.splice(o.payload, 1);
      break;
  }
}), ro = {
  sections: [],
  isStartHook: !1,
  isLoading: !1,
  status: i.INITIAL
}, Ns = (e) => {
  const [o, t] = H(
    so,
    ro
  ), s = R(() => {
    t({
      type: pe.INIT,
      payload: e
    });
  }, []), r = R((S) => {
    const u = {
      id: Ft(),
      name: (S == null ? void 0 : S.name) || "New section",
      description: (S == null ? void 0 : S.description) || "",
      expression: (S == null ? void 0 : S.expression) || {}
    };
    t({
      type: pe.ADD_SECTION,
      payload: u
    });
  }, []), E = R(
    (S) => {
      const u = o.sections[S];
      t({
        type: pe.COPY_SECTION,
        payload: {
          id: S + 1,
          section: {
            ...u,
            name: `Copy of: ${u.name}`
          }
        }
      });
    },
    [o]
  ), a = R((S) => {
    t({
      type: pe.REMOVE_SECTION,
      payload: S
    });
  }, []), c = R(
    (S, u, _) => {
      const l = o.sections[S];
      t({
        type: pe.UPDATE_SECTION,
        payload: {
          section: {
            ...l,
            [u]: _
          },
          id: S
        }
      });
    },
    [o]
  );
  return b(() => {
    e && s();
  }, []), {
    ...o,
    addSection: r,
    removeSection: a,
    updateSection: c,
    copySection: E
  };
};
var Ie = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_SECTION = "ADD_SECTION", e.COPY_SECTION = "COPY_SECTION", e.REMOVE_SECTION = "REMOVE_SECTION", e.UPDATE_SECTION = "UPDATE_SECTION", e))(Ie || {});
const ao = (e, o) => me(e, (t) => {
  var s;
  switch (o.type) {
    case Ie.INIT:
      t.sections = o.payload, t.ids = At(o.payload), t.status = i.SUCCESS;
      break;
    case Ie.ADD_SECTION:
      t.sections = t.sections.map((r) => ({
        ...r,
        defaultState: !1
      })), t.sections.push({ ...o.payload, defaultState: !0 }), t.ids[o.payload.id] = !0;
      break;
    case Ie.COPY_SECTION: {
      const { index: r, section: E } = o.payload, a = {
        ...E,
        defaultState: !0
      };
      t.sections = t.sections.map((c) => ({
        ...c,
        defaultState: !1
      })), t.sections.splice(r + 1, 0, a), t.ids[E.id] = !0;
      break;
    }
    case Ie.UPDATE_SECTION:
      if (o.payload.index >= 0) {
        const { index: r, field: E, value: a } = o.payload, c = { ...t.sections[r], [E]: a };
        t.sections.splice(o.payload.index, 1, c);
      }
      break;
    case Ie.REMOVE_SECTION: {
      const r = (s = t.sections[o.payload]) == null ? void 0 : s.id;
      t.sections.splice(o.payload, 1), delete t.ids[r];
      break;
    }
  }
}), Eo = {
  sections: [],
  status: i.INITIAL,
  ids: {}
}, xe = (e) => (e || "").trim().toLowerCase(), rt = (e, o = []) => {
  const t = xe(e);
  if (!t)
    return e;
  const s = new Set(
    o.map((a) => xe(a == null ? void 0 : a.name))
  );
  if (!s.has(t))
    return e;
  let r = 1, E = `${e} (${r})`;
  for (; s.has(xe(E)); )
    r += 1, E = `${e} (${r})`;
  return E;
}, Ls = (e) => {
  const [o, t] = H(ao, {
    ...Eo,
    sections: e,
    ids: At(e)
  }), { enqueueSnackbar: s } = yt(), r = (_) => {
    try {
      const l = ze(o.ids), I = ((_ == null ? void 0 : _.name) || "New section").trim() || "New section", T = rt(I, o.sections), y = {
        ..._,
        id: l,
        name: T,
        description: (_ == null ? void 0 : _.description) || "",
        expression: (_ == null ? void 0 : _.expression) || {}
      };
      t({
        type: Ie.ADD_SECTION,
        payload: y
      });
    } catch {
      s({
        message: "Concept Set limit exceeded (100 items)",
        variant: "error"
      });
    }
  }, E = (_) => {
    try {
      const l = ze(o.ids), I = `Copy of ${o.sections[_].name}`.trim(), T = rt(I, o.sections), y = {
        ...o.sections[_],
        name: T,
        id: l
      };
      t({
        type: Ie.COPY_SECTION,
        payload: { index: _, section: y }
      });
    } catch {
      s({
        message: "Concept Set limit exceeded (100 items)",
        variant: "error"
      });
    }
  }, a = (_) => {
    t({
      type: Ie.REMOVE_SECTION,
      payload: _
    });
  }, c = R((_) => {
    t({
      type: Ie.INIT,
      payload: _
    });
  }, []), S = R(
    (_, l, I) => {
      t({
        type: Ie.UPDATE_SECTION,
        payload: {
          field: l,
          value: I,
          index: _
        }
      });
    },
    [o]
  ), u = R(
    (_) => o.sections[_],
    [o.sections]
  );
  return {
    ...o,
    addSection: r,
    removeSection: a,
    updateSection: S,
    copySection: E,
    exportSection: u,
    syncSections: c
  };
}, no = {
  selectedConcepts: {}
};
var ae = /* @__PURE__ */ ((e) => (e.ADD_SELECTED_CONCEPT = "ADD_SELECTED_CONCEPT", e.REMOVE_SELECTED_CONCEPT = "REMOVE_SELECTED_CONCEPT", e.ADD_ALL_SELECTED_ELEMENT = "ADD_ALL_SELECTED_ELEMENT", e.REMOVE_ALL_SELECTED_ELEMENT = "REMOVE_ALL_SELECTED_ELEMENT", e.UPDATE_SELECTED_CONCEPT = "UPDATE_SELECTED_CONCEPT", e.UPDATE_SELECTED_CONCEPT_BULK = "UPDATE_SELECTED_CONCEPT_BULK", e.INIT = "INIT", e.CLEAR = "CLEAR", e))(ae || {});
const co = (e, o) => me(e, (t) => {
  switch (o.type) {
    case ae.INIT:
      t.selectedConcepts = o.payload;
      break;
    case ae.CLEAR:
      t.selectedConcepts = {};
      break;
    case ae.ADD_SELECTED_CONCEPT:
      {
        const { concept: r, id: E } = o.payload;
        t.selectedConcepts[r[E]] = r;
      }
      break;
    case ae.UPDATE_SELECTED_CONCEPT:
      {
        const { concept: r, id: E } = o.payload;
        t.selectedConcepts[r[E]] = r;
      }
      break;
    case ae.UPDATE_SELECTED_CONCEPT_BULK: {
      const { rows: r, accessor: E } = o.payload;
      for (const a of r)
        t.selectedConcepts[a.row[E]] && (t.selectedConcepts[a.row[E]][a.columnId] = a.value);
      break;
    }
    case ae.REMOVE_SELECTED_CONCEPT:
      {
        const { concept: r, id: E } = o.payload;
        delete t.selectedConcepts[r[E]];
      }
      break;
    case ae.ADD_ALL_SELECTED_ELEMENT:
      const s = {
        ...t.selectedConcepts,
        ...o.payload.rows
      };
      o.payload.ids && Object.keys(s).forEach((r) => {
        o.payload.ids[r] || delete s[r];
      }), t.selectedConcepts = s;
      break;
    case ae.REMOVE_ALL_SELECTED_ELEMENT:
      {
        const { concepts: r, id: E } = o.payload;
        r.forEach((a) => {
          delete t.selectedConcepts[a[E]];
        });
      }
      break;
  }
}), Ds = (e, o = "conceptId") => {
  const [t, s] = H(
    co,
    no
  ), r = () => {
    s({
      type: ae.CLEAR
    });
  }, E = (u) => {
    s({
      type: ae.INIT,
      payload: u
    });
  }, a = (u, _) => {
    s({
      type: ae.ADD_ALL_SELECTED_ELEMENT,
      payload: { rows: u, ids: _ }
    });
  }, c = (u) => {
    s({
      type: ae.UPDATE_SELECTED_CONCEPT,
      payload: {
        id: o,
        concept: u
      }
    });
  }, S = (u) => {
    s({
      type: ae.UPDATE_SELECTED_CONCEPT_BULK,
      payload: {
        accessor: o,
        rows: u
      }
    });
  };
  return b(() => {
    e && Object.keys(e).length && E(e);
  }, []), {
    ...t,
    clear: r,
    init: E,
    detectSelectedAction: a,
    updateSelectedConcept: c,
    updateSelectedConceptBulk: S
  };
};
function hs(e, o) {
  const t = _e(null);
  b(() => {
    t.current = e;
  }, [e]), b(() => {
    function s() {
      t.current();
    }
    if (o !== null) {
      let r = setInterval(s, o);
      return () => clearInterval(r);
    }
  }, [o]);
}
function ms(e, o, t = 1e3, s) {
  const r = _e(e), E = _e(null), a = _e(s);
  return b(() => {
    r.current = e, a.current = s;
  }, [e, s]), b(() => {
    if (t !== null)
      return E.current = setInterval(() => {
        r.current(), o() && (E.current && (clearInterval(E.current), E.current = null), a.current && a.current());
      }, t), () => {
        E.current && clearInterval(E.current);
      };
  }, [t, o]), R(() => {
    E.current && clearInterval(E.current);
  }, []);
}
var te = /* @__PURE__ */ ((e) => (e.LOAD_METADATA_REQUEST = "LOAD_METADATA_REQUEST", e.LOAD_METADATA_REQUEST_DONE = "LOAD_METADATA_REQUEST_DONE", e.LOAD_METADATA_REQUEST_FAILED = "LOAD_METADATA_REQUEST_FAILED", e.ADD_ATTRIBUTE_REQUEST = "ADD_ATTRIBUTE_REQUEST", e.ADD_ATTRIBUTE_REQUEST_DONE = "ADD_ATTRIBUTE_REQUEST_DONE", e.UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE", e.UPDATE_ATTRIBUTES_SETTINGS = "UPDATE_ATTRIBUTES_SETTINGS", e.REMOVE_ATTRIBUTE = "REMOVE_ATTRIBUTE", e))(te || {});
const lo = {
  isLoading: !1,
  status: i.INITIAL,
  data: [],
  pageCount: 1,
  pageNumber: 0,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  changeMessage: null
}, To = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case te.LOAD_METADATA_REQUEST:
      t.isLoading = !0, t.status = i.IN_PROGRESS;
      break;
    case te.LOAD_METADATA_REQUEST_DONE:
      t.isLoading = !1, t.status = i.SUCCESS, t.data = o.payload.content;
      break;
    case te.LOAD_METADATA_REQUEST_FAILED:
      t.isLoading = !1, t.status = i.ERROR;
      break;
    case te.ADD_ATTRIBUTE_REQUEST:
      t.changeMessage = null, t.isLoading = !0;
      break;
    case te.ADD_ATTRIBUTE_REQUEST_DONE:
      t.isLoading = !1, t.data.push(o.payload), t.changeMessage = `Create attribute ${o.payload.name}`;
      break;
    case te.UPDATE_ATTRIBUTE:
      const s = t.data.findIndex(
        (E) => E.id === o.payload.id
      );
      t.data[s] = o.payload, t.isLoading = !1, t.changeMessage = `Update attribute ${o.payload.name}`;
      break;
    case te.REMOVE_ATTRIBUTE:
      const r = t.data.findIndex(
        (E) => E.id === o.payload
      );
      t.data.splice(r, 1), t.changeMessage = "Remove attribute";
      break;
  }
}), _o = (e, o = "") => {
  const { pageNumber: t = 0, pageSize: s = 10, sortBy: r, query: E = "" } = e, a = Rt(r), c = `/admin/metadata-attribute/list?${E}&size=${s}&page=${t}&sort=${a}${o}`;
  return K.get(c);
}, at = (e) => {
  const o = e == null ? void 0 : e.toLowerCase();
  return !!(o != null && o.startsWith("ai-") && o !== "ai-generated");
}, io = (e, o) => e.filter(
  ({ name: t }) => o ? at(t) : !at(t)
), Us = (e, o, t, s, r, E) => {
  const [a, c] = H(
    To,
    lo
  ), S = R(async () => {
    c({
      type: te.LOAD_METADATA_REQUEST
    });
    try {
      const T = await _o(
        {
          pageNumber: 0,
          pageSize: 1e6
        },
        e
      );
      c({
        type: te.LOAD_METADATA_REQUEST_DONE,
        payload: t ? T : { ...T, content: io(T.content, o) }
      });
    } catch {
    }
  }, [e, o, t]), u = R(
    async (T) => {
      c({
        type: te.ADD_ATTRIBUTE_REQUEST
      });
      const y = {
        id: T.id,
        name: T.title,
        type: T.type,
        options: T.options,
        required: !1,
        filterable: !1,
        searchable: !1,
        visible: !1,
        metadataSubjects: T.metadataSubjects
      };
      try {
        const O = await s(y);
        c({
          type: te.ADD_ATTRIBUTE_REQUEST_DONE,
          payload: O
        });
      } catch {
      }
    },
    [a]
  ), _ = R(
    async (T, y) => {
      c({
        type: te.ADD_ATTRIBUTE_REQUEST
      });
      const O = {
        id: y.id,
        name: T.title,
        type: T.type,
        options: T.options,
        required: y.required,
        filterable: y.filterable,
        searchable: y.searchable,
        visible: y.visible,
        metadataSubjects: T.metadataSubjects
      };
      try {
        const N = await r(O.id, O);
        c({
          type: te.UPDATE_ATTRIBUTE,
          payload: N
        });
      } catch {
      }
    },
    [a]
  ), l = R(
    async (T) => {
      const y = {
        ...a.data[T.rowIndex],
        [T.columnId]: T.value
      };
      try {
        const O = await r(y.id, y);
        c({
          type: te.UPDATE_ATTRIBUTE,
          payload: O
        });
      } catch {
      }
    },
    [a.data]
  ), I = R(async (T) => {
    try {
      await E(T), c({
        type: te.REMOVE_ATTRIBUTE,
        payload: T
      });
    } catch {
    }
  }, []);
  return b(() => {
    S();
  }, [o]), {
    ...a,
    getMetadata: S,
    addAttribute: u,
    updateAttribute: _,
    editAttribute: l,
    removeAttribute: I
  };
};
var ue = /* @__PURE__ */ ((e) => (e.GET_VERIONS_LIST_REQUEST = "GET_VERIONS_LIST_REQUEST", e.GET_VERIONS_LIST_REQUEST_DONE = "GET_VERIONS_LIST_REQUEST_DONE", e.GET_VERIONS_LIST_REQUEST_FAILED = "GET_VERIONS_LIST_REQUEST_FAILED", e.GET_CURRENT_VERSION_REQUEST = "GET_CURRENT_VERSION_REQUEST", e.GET_CURRENT_VERSION_REQUEST_DONE = "GET_CURRENT_VERSION_REQUEST_DONE", e.GET_CURRENT_VERSION_REQUEST_FAILED = "GET_CURRENT_VERSION_REQUEST_FAILED", e))(ue || {});
const So = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case ue.GET_VERIONS_LIST_REQUEST:
      t.isLoading = !0;
      break;
    case ue.GET_VERIONS_LIST_REQUEST_DONE:
      t.isStartHook = !0, t.isLoading = !1, t.versions = o.payload.versions, t.totalElements = o.payload.totalElements;
      break;
    case ue.GET_CURRENT_VERSION_REQUEST_DONE:
      t.currentVersion = o.payload;
  }
}), uo = {
  versions: [],
  currentVersion: null,
  isStartHook: !1,
  isLoading: !1,
  error: null,
  totalElements: 0
}, gs = (e, o, t, s, r, E) => {
  const [a, c] = H(
    So,
    uo
  ), S = R(async () => {
    if (c({
      type: ue.GET_VERIONS_LIST_REQUEST
    }), !e)
      return c({
        type: ue.GET_VERIONS_LIST_REQUEST_DONE,
        payload: []
      }), 0;
    try {
      const l = await t(e);
      c({
        type: ue.GET_VERIONS_LIST_REQUEST_DONE,
        payload: {
          versions: kt(
            l.content,
            o,
            E
          ),
          totalElements: l.totalElements
        }
      });
    } catch {
      c({
        type: ue.GET_VERIONS_LIST_REQUEST_FAILED
      });
    }
  }, []), u = R(async (l) => {
    var I, T, y, O, N, L;
    c({
      type: ue.GET_CURRENT_VERSION_REQUEST
    });
    try {
      const A = await s(l);
      c({
        type: ue.GET_CURRENT_VERSION_REQUEST_DONE,
        payload: {
          ...A.data,
          name: `${((I = A.data) == null ? void 0 : I.name) || ((T = A.data) == null ? void 0 : T.title)} (Version #${A.ordinal})`,
          title: `${((y = A.data) == null ? void 0 : y.name) || ((O = A.data) == null ? void 0 : O.title)} (Version #${A.ordinal})`,
          originName: `${((N = A.data) == null ? void 0 : N.name) || ((L = A.data) == null ? void 0 : L.title)}`,
          versionId: A.id
        }
      });
    } catch {
      c({
        type: ue.GET_CURRENT_VERSION_REQUEST_FAILED
      });
    }
  }, []), _ = R(async (l) => {
    try {
      const I = await s(l);
      r(I.data);
    } catch {
    }
  }, []);
  return b(() => {
    S();
  }, []), {
    ...a,
    getCurrentVersion: u,
    getListVersions: S,
    copyVersion: _
  };
};
var X = /* @__PURE__ */ ((e) => (e.GET_VALUES_REQUEST = "GET_VALUES_REQUEST", e.GET_VALUES_REQUEST_DONE = "GET_VALUES_REQUEST_DONE", e.GET_VALUES_REQUEST_FAILED = "GET_VALUES_REQUEST_FAILED", e.CREATE_VALUE = "CREATE_VALUE", e.UPDATE_VALUE = "UPDATE_VALUE", e.DELETE_VALUE = "DELETE_VALUE", e.CHANGE_VALUE_REQUEST = "CHANGE_VALUE_REQUEST", e.CHANGE_VALUE_REQUEST_DONE = "CHANGE_VALUE_REQUEST_DONE", e.CHANGE_VALUE_REQUEST_FAILED = "CHANGE_VALUE_REQUEST_FAILED", e.CREATE_VALUE_REQUEST = "CREATE_VALUE_REQUEST", e.CREATE_VALUE_REQUEST_DONE = "CREATE_VALUE_REQUEST_DONE", e.CREATE_VALUE_REQUEST_FAILED = "CREATE_VALUE_REQUEST_FAILED", e.COPY_VALUE_REQUEST = "COPY_VALUE_REQUEST", e.COPY_VALUE_REQUEST_DONE = "COPY_VALUE_REQUEST_DONE", e.COPY_VALUE_REQUEST_FAILED = "COPY_VALUE_REQUEST_FAILED", e))(X || {}), Se = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LOADING_METADATA = "LOADING_METADATA", e.LOADED_METADATA = "LOADED_METADATA", e.ERROR_LOADED_METADATA = "ERROR_LOADED_METADATA", e.LOADING_CREATE_METADATA = "LOADING_CREATE_METADATA", e.LOADED_CREATE_METADATA = "LOADED_CREATE_METADATA", e.ERROR_LOADED_CREATE_METADATA = "ERROR_LOADED_CREATE_METADATA", e.LOADING_COPY_METADATA = "LOADING_COPY_METADATA", e.LOADED_COPY_METADATA = "LOADED_COPY_METADATA", e.ERROR_LOADED_COPY_METADATA = "ERROR_LOADED_COPY_METADATA", e))(Se || {});
const po = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case X.GET_VALUES_REQUEST:
      t.status = Se.LOADING_METADATA;
      break;
    case X.GET_VALUES_REQUEST_DONE:
      t.values = o.payload, t.status = Se.LOADED_METADATA;
      break;
    case X.GET_VALUES_REQUEST_FAILED:
      t.values = [], t.status = Se.ERROR_LOADED_METADATA, t.error = o.payload;
      break;
    case X.CREATE_VALUE_REQUEST:
      t.status = Se.LOADING_CREATE_METADATA;
      break;
    case X.CREATE_VALUE_REQUEST_DONE:
      t.status = Se.LOADED_CREATE_METADATA, t.values = o.payload;
      break;
    case X.CREATE_VALUE_REQUEST_FAILED:
      t.status = Se.ERROR_LOADED_CREATE_METADATA, t.values = [], t.error = o.payload;
      break;
    case X.COPY_VALUE_REQUEST:
      t.status = Se.LOADING_COPY_METADATA;
      break;
    case X.COPY_VALUE_REQUEST_DONE:
      t.status = Se.LOADED_COPY_METADATA;
      break;
    case X.COPY_VALUE_REQUEST_FAILED:
      t.status = Se.ERROR_LOADED_COPY_METADATA, t.error = o.payload;
      break;
  }
}), Io = {
  values: [],
  isStartHook: !1,
  isLoading: !1,
  error: null,
  status: Se.INITIAL
}, Et = (e) => {
  const o = e == null ? void 0 : e.toLowerCase();
  return !!(o != null && o.startsWith("ai-") && o !== "ai-generated");
}, nt = (e, o) => e.filter(
  ({ attribute: t }) => o ? Et(t == null ? void 0 : t.name) : !Et(t == null ? void 0 : t.name)
), bs = (e, o, t) => {
  const [s, r] = H(
    po,
    Io
  ), {
    entityFilter: E,
    getListValues: a,
    updateMetadataValue: c,
    removeMetadataValue: S,
    createMetadataValue: u,
    copyMetadataValue: _
  } = o, l = R(
    async (y) => {
      r({
        type: X.GET_VALUES_REQUEST
      });
      try {
        const O = await a(
          `filter.metadata.value.${E}.id`,
          y
        );
        r({
          type: X.GET_VALUES_REQUEST_DONE,
          payload: nt(O.content, t)
        });
      } catch {
      }
    },
    [t, E, a]
  ), I = R(
    async (y, O) => {
      r({
        type: X.CREATE_VALUE_REQUEST
      });
      const N = [];
      Object.keys(y).forEach((L) => {
        const A = y[L], U = O[L];
        (U.type === fe.STRING || U.type === fe.INTEGER) && (A.values.valueId ? A.values.value ? N.push(
          c(
            {
              attribute: {
                id: A.attributeId
              },
              dataSourceId: A.dataSourceId,
              value: A.values.value
            },
            A.values.valueId
          )
        ) : N.push(S(A.values.valueId)) : A.values.value && N.push(
          u({
            attribute: {
              id: A.attributeId
            },
            dataSourceId: A.dataSourceId,
            value: A.values.value
          })
        )), (U.type === fe.ENUM || U.type === fe.ENUM_MULTI) && (A.values.forEach((P) => {
          U.values.find(
            (Y) => Y.attributeOption.id === P.optionId
          ) || N.push(
            u({
              attribute: {
                id: A.attributeId
              },
              attributeOption: {
                id: P.optionId,
                value: P.value
              },
              dataSourceId: A.dataSourceId
            })
          );
        }), U.values.forEach((P) => {
          A.values.find(
            (Y) => Y.optionId === P.attributeOption.id
          ) || N.push(S(P.id));
        }));
      });
      try {
        await Promise.all(N);
        const L = await a(
          `filter.metadata.value.${E}.id`,
          e
        );
        r({
          type: X.CREATE_VALUE_REQUEST_DONE,
          payload: nt(L.content, t)
        });
      } catch {
      }
    },
    [
      t,
      u,
      E,
      e,
      a,
      S,
      c
    ]
  ), T = R(
    async (y, O) => {
      r({
        type: X.COPY_VALUE_REQUEST
      });
      try {
        await _(y, {
          targetIds: O.map((N) => N.id)
        }), r({
          type: X.COPY_VALUE_REQUEST_DONE
        });
      } catch {
        r({
          type: X.COPY_VALUE_REQUEST_FAILED
        });
      }
    },
    [_]
  );
  return b(() => {
    l(e);
  }, [e, l]), {
    ...s,
    saveMetadataValue: I,
    getMetadataValues: l,
    copyMetadataValues: T
  };
}, Ao = {
  entity: null,
  actions: {},
  version: null,
  draft: null,
  isVersionMode: !1,
  status: i.INITIAL,
  error: null
}, Ro = (e, o, t) => {
  const { enqueueSnackbar: s } = yt(), [r, E] = H(
    yo,
    Ao
  ), a = R(async () => {
    E({
      type: "GET_ENTITY"
      /* GET_ENTITY */
    });
    try {
      let T = await e.get(o);
      E({
        type: "GET_ENTITY_SUCCESS",
        payload: { data: T }
      });
    } catch (T) {
      E({
        type: "GET_ENTITY_ERROR",
        payload: { error: T }
      });
    }
  }, [o]), c = R(async () => {
    E({
      type: "DELETE_ENTITY"
      /* DELETE_ENTITY */
    });
    try {
      let T = await e.delete(o);
      E({
        type: "DELETE_ENTITY_SUCCESS",
        payload: { data: T }
      }), s({
        message: (t || "Entity") + " deleted successfully.",
        variant: "success"
      });
    } catch (T) {
      E({
        type: "DELETE_ENTITY_ERROR",
        payload: { error: T }
      }), s({
        message: "Something went wrong. " + T.message,
        variant: "error"
      });
    }
  }, [o]), S = R(
    async (T) => {
      E({
        type: "UPDATE_ENTITY"
        /* UPDATE_ENTITY */
      });
      try {
        let y = await e.update(T, o);
        E({
          type: "UPDATE_ENTITY_SUCCESS",
          payload: { data: y }
        }), s({
          message: (t || "Entity") + " updated successfully.",
          variant: "success"
        });
      } catch (y) {
        console.error(y), E({
          type: "UPDATE_ENTITY_ERROR",
          payload: { error: y }
        }), s({
          message: "Something went wrong. " + y.message,
          variant: "error"
        });
      }
    },
    [o]
  ), u = R(
    async (T) => {
      E({
        type: "COPY_ENTITY"
        /* COPY_ENTITY */
      });
      try {
        let y = await e.copy(
          T.id,
          `Copy of ${T.name || T.title}`
        );
        return E({
          type: "UPDATE_ENTITY_SUCCESS",
          payload: { data: y }
        }), s({
          message: (t || "Entity") + " copied successfully.",
          variant: "success"
        }), y;
      } catch (y) {
        E({
          type: "UPDATE_ENTITY_ERROR",
          payload: { error: y }
        }), s({
          message: "Something went wrong. " + y.message,
          variant: "error"
        });
      }
    },
    [o]
  ), _ = R(
    (T) => {
      E({
        type: "SET_VERSION",
        payload: {
          ...T,
          revertVersionId: T.versionId,
          versionId: r.draft.versionId
        }
      });
    },
    [r.draft]
  ), l = (T) => {
    E({
      type: "NON_PERSIST_UPDATE",
      payload: T
    });
  }, I = () => {
    E({
      type: "REVERT_VERSION"
      /* REVERT_VERSION */
    });
  };
  return b(() => {
    o != "new" && a();
  }, [o]), {
    ...r,
    getEntity: a,
    copyEntity: u,
    deleteEntity: c,
    updateEntity: S,
    setVersionEntity: _,
    revertEntity: I,
    noPersistUpdate: l
  };
}, yo = (e, o) => me(e, (t) => {
  var s, r;
  switch (o.type) {
    case "GET_ENTITY":
      t.status = e.status === i.INITIAL ? i.IN_PROGRESS : i.IN_PROGRESS_RELOAD;
      break;
    case "GET_ENTITY_SUCCESS":
      if (o.payload.data == null) {
        t.error = { message: "Not found" }, t.status = i.ERROR;
        break;
      }
      t.entity = o.payload.data, t.draft = o.payload.data, t.actions = Qe((s = o.payload.data) == null ? void 0 : s.actions), t.status = i.SUCCESS;
      break;
    case "GET_ENTITY_ERROR":
      t.error = { ...o.payload.error, message: "Not found" }, t.status = i.ERROR;
      break;
    case "DELETE_ENTITY":
      t.status = i.IN_PROGRESS;
      break;
    case "DELETE_ENTITY_SUCCESS":
      t.status = i.SUCCESS;
      break;
    case "DELETE_ENTITY_ERROR":
      t.status = i.ERROR;
      break;
    case "UPDATE_ENTITY":
      t.status = i.IN_PROGRESS_RELOAD;
      break;
    case "UPDATE_ENTITY_SUCCESS":
      t.isVersionMode = !1, t.version = null, t.entity = o.payload.data, t.actions = Qe((r = o.payload.data) == null ? void 0 : r.actions), t.draft = o.payload.data, t.status = i.SUCCESS;
      break;
    case "UPDATE_ENTITY_ERROR":
      t.status = i.ERROR;
      break;
    case "NON_PERSIST_UPDATE":
      t.entity = o.payload, t.draft = o.payload, t.actions = Qe(o.payload.actions);
      break;
    case "SET_VERSION":
      t.version = o.payload, t.draft = o.payload, t.isVersionMode = !0;
      break;
    case "REVERT_VERSION":
      t.version = null, t.isVersionMode = !1, t.draft = t.entity;
      break;
  }
});
var B = /* @__PURE__ */ ((e) => (e.SET_DESIGN = "SET_DESIGN", e.SET_DESIGN_SUCCESS = "SET_DESIGN_SUCCESS", e.SET_DESIGN_ERROR = "SET_DESIGN_ERROR", e.UPDATE_DESIGN = "UPDATE_DESIGN", e.UPDATE_DESIGN_BASE = "UPDATE_DESIGN_BASE", e.SAVE_DESIGN = "SAVE_DESIGN", e.SAVE_DESIGN_SUCCESS = "SAVE_DESIGN_SUCCESS", e.SAVE_DESIGN_ERROR = "SAVE_DESIGN_ERROR", e.RELOAD_DESIGN_SUCCESS = "RELOAD_DESIGN_SUCCESS", e.GET_SUMMARY = "GET_SUMMARY", e))(B || {});
const Oo = {
  design: null,
  designStatus: i.INITIAL,
  designError: null,
  summary: {}
  // analysisTypeData: {},
}, Co = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case B.SET_DESIGN:
      t.designStatus = i.IN_PROGRESS, t.designError = null, t.design = null;
      break;
    case B.RELOAD_DESIGN_SUCCESS:
      t.design = {
        ...t.design,
        design: o.payload
      };
      break;
    case B.SET_DESIGN_SUCCESS:
      t.designStatus = i.SUCCESS, t.design = o.payload;
      break;
    case B.SET_DESIGN_ERROR:
      t.designStatus = i.ERROR, t.designError = o.payload;
      break;
    case B.UPDATE_DESIGN:
      t.design.design[o.payload.key] = o.payload.value;
      break;
    case B.UPDATE_DESIGN_BASE:
      t.design = {
        ...t.design,
        ...o.payload
      };
      break;
    case B.SAVE_DESIGN:
      t.designStatus = i.IN_PROGRESS;
      break;
    case B.SAVE_DESIGN_SUCCESS:
      t.designStatus = i.SUCCESS;
      break;
    case B.GET_SUMMARY:
      t.summary = o.payload;
      break;
    case B.SAVE_DESIGN_ERROR:
      t.designStatus = i.ERROR;
      break;
  }
});
function ct(e, o) {
  return {
    name: e.name,
    description: e.description || void 0,
    expression: {
      items: Object.values(o).map((t) => {
        const { id: s, ...r } = t, E = t.excluded ?? t.isExcluded;
        return {
          ...r,
          concept: null,
          isExcluded: E ?? !1,
          excluded: E ?? !1,
          hierarchy: t.hierarchy ?? !1,
          includeDescendants: t.includeDescendants ?? !1,
          includeMapped: t.includeMapped ?? !1
        };
      })
    }
  };
}
const Lt = ["bt", "!bt"], Dt = (e) => {
  switch (e) {
    case "lt":
    case "lte":
    case "eq":
    case "gt":
    case "gte":
    case "bt":
    case "!bt":
      return e;
    case "<":
    case "less than":
      return "lt";
    case "<=":
    case "less or equal to":
      return "lte";
    case "=":
    case "equal to":
      return "eq";
    case ">":
    case "greater than":
      return "gt";
    case ">=":
    case "greater or equal to":
      return "gte";
    case "between":
    case "beetwen":
      return "bt";
    case "not between":
    case "not beetwen":
      return "!bt";
    default:
      return "gt";
  }
}, ht = (e) => {
  const o = Dt(e == null ? void 0 : e.Op), t = (e == null ? void 0 : e.Extent) ?? null;
  return {
    Op: o,
    Value: (e == null ? void 0 : e.Value) ?? null,
    Extent: Lt.includes(o) ? t : null
  };
}, No = (e) => Array.isArray(e) ? e.filter((o) => o == null ? void 0 : o.versionId).map((o) => ({
  versionId: o.versionId,
  ...o.alias ? { alias: o.alias } : {}
})) : [], lt = (e) => ({
  ...e,
  targetCohorts: No(e == null ? void 0 : e.targetCohorts),
  visitLength: ht(e == null ? void 0 : e.visitLength),
  dateRangeStart: (e == null ? void 0 : e.dateRangeStart) ?? null,
  dateRangeEnd: (e == null ? void 0 : e.dateRangeEnd) ?? null
}), mt = (e = {}) => {
  var u, _, l;
  const o = Dt((u = e == null ? void 0 : e.visitLength) == null ? void 0 : u.Op), t = ((_ = e == null ? void 0 : e.visitLength) == null ? void 0 : _.Value) ?? null, s = ((l = e == null ? void 0 : e.visitLength) == null ? void 0 : l.Extent) ?? null, r = Lt.includes(o) && t !== null && s !== null && Number(t) >= Number(s), E = (e == null ? void 0 : e.dateRangeStart) ?? null, a = (e == null ? void 0 : e.dateRangeEnd) ?? null, c = !!E != !!a, S = !!(E && a && E > a);
  return {
    hasVisitLengthRangeError: r,
    hasDateRangePairError: c,
    hasDateRangeOrderError: S
  };
}, Lo = (e = {}) => {
  const {
    hasVisitLengthRangeError: o,
    hasDateRangePairError: t,
    hasDateRangeOrderError: s
  } = mt(e);
  return o || t || s;
}, Ps = (e, o, t, s, r) => {
  const { entity: E, draft: a, status: c, updateEntity: S, ...u } = Ro(e, o, t), {
    component: _,
    getTemplate: l,
    isUpload: I,
    atlasEntity: T,
    parseDesign: y,
    formatDesign: O,
    conceptSetAttr: N
  } = de(
    () => E != null && E.type && s && s[E.type] ? s[E.type] : {},
    [E == null ? void 0 : E.type, s]
  ), [L, A] = H(
    Co,
    Oo
  ), U = R(async () => {
    try {
      const D = await r(o);
      A({
        type: B.GET_SUMMARY,
        payload: D
      });
    } catch {
    }
  }, [o]), P = (D, p, C) => {
    var h, n, d, m, g, f, v, Ee, ne, G, q;
    switch (D) {
      case w.CUSTOM:
        return ((h = C == null ? void 0 : C.files) == null ? void 0 : h.length) > 0 && (C == null ? void 0 : C.executableFileName);
      case w.ESTIMATION:
        const ie = {
          doPositiveControlSynthesis: C.doPositiveControlSynthesis,
          cohortDefinitions: C.cohortDefinitions,
          conceptSetCrossReference: C.conceptSetCrossReference,
          conceptSets: C.conceptSets,
          negativeControlExposureCohortDefinition: C.negativeControlExposureCohortDefinition,
          negativeControls: C.negativeControls,
          positiveControlSynthesisArgs: C.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: C.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (m = (d = (n = C.estimationAnalysisSettings) == null ? void 0 : n.analysisSpecification) == null ? void 0 : d.targetComparatorOutcomes) == null ? void 0 : m.map(
            (Z) => ({
              comparatorId: Z.comparatorId,
              outcomeIds: Z.outcomeIds,
              targetId: Z.targetId
            })
          ),
          cohortMethodAnalysisList: (f = (g = C.estimationAnalysisSettings) == null ? void 0 : g.analysisSpecification) == null ? void 0 : f.cohortMethodAnalysisList
        }, z = {
          doPositiveControlSynthesis: p.doPositiveControlSynthesis,
          cohortDefinitions: p.cohortDefinitions,
          conceptSetCrossReference: p.conceptSetCrossReference,
          conceptSets: p.conceptSets,
          negativeControlExposureCohortDefinition: p.negativeControlExposureCohortDefinition,
          negativeControls: p.negativeControls,
          positiveControlSynthesisArgs: p.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: p.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (ne = (Ee = (v = p.estimationAnalysisSettings) == null ? void 0 : v.analysisSpecification) == null ? void 0 : Ee.targetComparatorOutcomes) == null ? void 0 : ne.map(
            (Z) => ({
              comparatorId: Z.comparatorId,
              outcomeIds: Z.outcomeIds,
              targetId: Z.targetId
            })
          ),
          cohortMethodAnalysisList: (q = (G = p.estimationAnalysisSettings) == null ? void 0 : G.analysisSpecification) == null ? void 0 : q.cohortMethodAnalysisList
        };
        return Te(ie, z);
      default:
        return Te({ ...l == null ? void 0 : l(), ...p }, C);
    }
  }, x = (D, p, C) => {
    var h, n, d, m, g, f, v, Ee, ne, G, q, ie;
    switch (D) {
      case w.CUSTOM:
        return Te(
          C == null ? void 0 : C.executableFileName,
          p == null ? void 0 : p.executableFileName
        ) && Te(C == null ? void 0 : C.cohorts, p == null ? void 0 : p.cohorts) && Te(C == null ? void 0 : C.conceptSets, p == null ? void 0 : p.conceptSets);
      case w.ESTIMATION: {
        const z = {
          doPositiveControlSynthesis: C.doPositiveControlSynthesis,
          cohortDefinitions: C.cohortDefinitions,
          conceptSetCrossReference: C.conceptSetCrossReference,
          conceptSets: C.conceptSets,
          negativeControlExposureCohortDefinition: C.negativeControlExposureCohortDefinition,
          negativeControls: C.negativeControls,
          positiveControlSynthesisArgs: C.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: C.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (d = (n = (h = C.estimationAnalysisSettings) == null ? void 0 : h.analysisSpecification) == null ? void 0 : n.targetComparatorOutcomes) == null ? void 0 : d.map(
            (le) => ({
              comparatorId: le.comparatorId,
              outcomeIds: le.outcomeIds,
              targetId: le.targetId
            })
          ),
          cohortMethodAnalysisList: (g = (m = C.estimationAnalysisSettings) == null ? void 0 : m.analysisSpecification) == null ? void 0 : g.cohortMethodAnalysisList
        }, re = {
          doPositiveControlSynthesis: p.doPositiveControlSynthesis,
          cohortDefinitions: p.cohortDefinitions,
          conceptSetCrossReference: p.conceptSetCrossReference,
          conceptSets: p.conceptSets,
          negativeControlExposureCohortDefinition: p.negativeControlExposureCohortDefinition,
          negativeControls: p.negativeControls,
          positiveControlSynthesisArgs: p.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: p.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (Ee = (v = (f = p.estimationAnalysisSettings) == null ? void 0 : f.analysisSpecification) == null ? void 0 : v.targetComparatorOutcomes) == null ? void 0 : Ee.map(
            (le) => ({
              comparatorId: le.comparatorId,
              outcomeIds: le.outcomeIds,
              targetId: le.targetId
            })
          ),
          cohortMethodAnalysisList: (G = (ne = p.estimationAnalysisSettings) == null ? void 0 : ne.analysisSpecification) == null ? void 0 : G.cohortMethodAnalysisList
        };
        return Te(z, re);
      }
      case w.COST: {
        const z = lt({
          ...l == null ? void 0 : l(),
          ...p
        }), re = lt(C);
        return Te(z, re);
      }
      default: {
        const z = JSON.parse(
          JSON.stringify({ ...l == null ? void 0 : l(), ...p })
        ), re = JSON.parse(JSON.stringify(C)), Z = (() => {
          switch (D) {
            case w.COHORT_CHARACTERIZATION:
              return "strataConceptSets";
            case w.INCIDENCE:
              return "conceptSets";
          }
        })(), le = {
          ...z,
          [Z]: (q = z == null ? void 0 : z[Z]) == null ? void 0 : q.map((j) => {
            var Oe;
            if (typeof j == "object" && j !== null) {
              const { uuid: Fe, type: ke, ...Ue } = j;
              return ct(Ue, (Oe = j.expression) == null ? void 0 : Oe.items);
            }
          }),
          ...z.ageBreaks ? z.ageBreaks.map((j) => (delete j.id, j)) : {}
        }, Ge = {
          ...re,
          [Z]: (ie = re == null ? void 0 : re[Z]) == null ? void 0 : ie.map((j) => {
            var Oe;
            if (typeof j == "object" && j !== null) {
              const { uuid: Fe, type: ke, ...Ue } = j;
              return ct(Ue, (Oe = j.expression) == null ? void 0 : Oe.items);
            }
          }),
          ...re.ageBreaks ? re.ageBreaks.map((j) => (delete j.id, j)) : {}
        };
        return Te(le, Ge);
      }
    }
  }, Y = (D, p, C) => {
    var d, m, g, f, v, Ee, ne, G, q, ie, z, re, Z, le, Ge, Me, j, Oe, Fe, ke, Ue, We, qe;
    let h = !0, n = [];
    switch (D) {
      case w.COHORT:
      case w.SIMPLE_COUNTS_CHARACTERIZATION:
        p.cohortVersionId || (h = !1, n.push("add target cohort"));
        break;
      case w.COHORT_PATHWAY:
        (!p.targetCohorts || ((d = p.targetCohorts) == null ? void 0 : d.length) < 1) && (h = !1, n.push("add target cohorts")), ((m = p.eventCohorts) == null ? void 0 : m.length) < 1 && (h = !1, n.push("add event cohorts"));
        break;
      case w.INCIDENCE:
        (!p.targetCohorts || ((g = p.targetCohorts) == null ? void 0 : g.length) < 1) && (h = !1, n.push("add target cohorts")), (!p.outcomeCohorts || ((f = p.outcomeCohorts) == null ? void 0 : f.length) < 1) && (h = !1, n.push("add outcome cohorts"));
        break;
      case w.CUSTOM: {
        ((v = p == null ? void 0 : p.files) == null ? void 0 : v.length) < 1 && (h = !1, n.push("upload files")), p != null && p.executableFileName || (h = !1, n.push("entry point not selected")), (Ee = p == null ? void 0 : p.cohorts) != null && Ee.length && !((ne = p == null ? void 0 : p.cohorts) != null && ne.every((Pe) => !!Pe.alias)) && (h = !1, n.push("add alias name for each target cohort")), (G = p == null ? void 0 : p.conceptSets) != null && G.length && !((q = p == null ? void 0 : p.conceptSets) != null && q.every((Pe) => !!Pe.alias)) && (h = !1, n.push("add alias name for each concept set"));
        break;
      }
      case w.ESTIMATION:
        ((re = (z = (ie = p.estimationAnalysisSettings) == null ? void 0 : ie.analysisSpecification) == null ? void 0 : z.targetComparatorOutcomes) == null ? void 0 : re.length) < 1 && (h = !1), ((Ge = (le = (Z = p.estimationAnalysisSettings) == null ? void 0 : Z.analysisSpecification) == null ? void 0 : le.cohortMethodAnalysisList) == null ? void 0 : Ge.length) < 1 && (h = !1);
        break;
      case w.COHORT_CHARACTERIZATION:
        (!p.featureAnalyses || ((Me = p.featureAnalyses) == null ? void 0 : Me.length) < 1) && (h = !1, n.push("add feature analyses"));
      case w.BULK_COHORT_COUNTS:
        (!p.cohorts || ((j = p.cohorts) == null ? void 0 : j.length) < 1) && (h = !1, n.push("add target cohorts"));
        break;
      case w.DATACUT:
        (!p.cohorts || ((Oe = p.cohorts) == null ? void 0 : Oe.length) < 1) && (h = !1, n.push("add target cohorts")), ((Fe = Object.keys(p.includedTables)) == null ? void 0 : Fe.length) < 1 && (h = !1, n.push("select OMOP CDM tables")), p.cohortOption || (h = !1, n.push("select data to export"));
        break;
      case w.FEASIBILITY:
        (!p.targetCohorts || ((ke = p.targetCohorts) == null ? void 0 : ke.length) < 1) && (h = !1, n.push("add target cohorts"));
        break;
      case w.TIME_TO_EVENT:
        (!p.targetCohorts || ((Ue = p.targetCohorts) == null ? void 0 : Ue.length) < 1) && (h = !1, n.push("add target cohorts")), ((We = p.eventCohorts) == null ? void 0 : We.length) < 1 && (h = !1, n.push("add outcome cohorts"));
        break;
      case w.COST: {
        (!p.targetCohorts || ((qe = p.targetCohorts) == null ? void 0 : qe.length) < 1) && (h = !1, n.push("add target cohorts"));
        const {
          hasVisitLengthRangeError: Pe,
          hasDateRangePairError: gt,
          hasDateRangeOrderError: bt
        } = mt(C);
        Pe && (h = !1, n.push("set visit length start value less than end value")), gt && (h = !1, n.push("fill both event dates or leave both empty")), bt && (h = !1, n.push("set event start date not later than end date"));
        break;
      }
    }
    return { canExecute: h, messages: n };
  }, Q = de(() => {
    var d, m, g, f, v;
    const D = c === i.SUCCESS && L.designStatus === i.SUCCESS ? Y(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((d = L.design) == null ? void 0 : d.design) || {}
    ) : { canExecute: !1, messages: [] }, p = (a == null ? void 0 : a.type) === w.COST ? Lo(((m = L.design) == null ? void 0 : m.design) || {}) : !1, C = c === i.SUCCESS && L.designStatus === i.SUCCESS ? x(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((g = L.design) == null ? void 0 : g.design) || {}
    ) && Te(a == null ? void 0 : a.title, (f = L.design) == null ? void 0 : f.title) && Te(a == null ? void 0 : a.description, (v = L.design) == null ? void 0 : v.description) || p : !0, h = D.canExecute, n = D.messages;
    return {
      disableSave: C,
      canExecute: h,
      executionMessages: n
    };
  }, [a, L.design, l, c, L.designStatus]), se = de(() => {
    var h, n, d, m, g, f, v;
    const D = P(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((h = L.design) == null ? void 0 : h.design) || {}
    ), p = (d = (n = L.design) == null ? void 0 : n.studyWindow) != null && d.startDate ? !Xe(
      L.design.studyWindow.startDate,
      Je.ISO_DATE
    ) : !1, C = (g = (m = L.design) == null ? void 0 : m.studyWindow) != null && g.endDate ? !Xe(
      L.design.studyWindow.endDate,
      Je.ISO_DATE
    ) : !1;
    return D && Te(a == null ? void 0 : a.title, (f = L.design) == null ? void 0 : f.title) && Te(a == null ? void 0 : a.description, (v = L.design) == null ? void 0 : v.description) || p || C;
  }, [a, L.design, l]), $ = (D = []) => D.filter(
    (p) => p.currentVersionId && p.versionId !== p.currentVersionId
  ), be = de(() => {
    var h, n;
    const D = (h = L.design) == null ? void 0 : h.design, p = (n = L.design) == null ? void 0 : n.type;
    let C = [];
    switch (p) {
      case w.COHORT_CHARACTERIZATION:
        C = $(D.cohorts);
        break;
      case w.INCIDENCE:
        C = [
          ...$(D.targetCohorts),
          ...$(D.outcomeCohorts)
        ];
        break;
      case w.COHORT_PATHWAY:
        C = [
          ...$(D.targetCohorts),
          ...$(D.eventCohorts)
        ];
        break;
      case w.ESTIMATION:
        C = [...$(D.cohortDefinitions)];
        break;
      case w.BULK_COHORT_COUNTS:
      case w.CUSTOM:
        C = $(D.cohorts);
        break;
    }
    return C;
  }, [a, L.design]), Re = R(
    (D) => {
      A({
        type: B.SET_DESIGN
      });
      const p = l == null ? void 0 : l();
      try {
        setTimeout(() => {
          A({
            type: B.SET_DESIGN_SUCCESS,
            payload: {
              ...D,
              design: {
                ...p,
                ...D.design
              }
            }
          });
        }, 500);
      } catch (C) {
        A({
          type: B.SET_DESIGN_ERROR,
          payload: C
        });
      }
    },
    [l]
  ), V = (D) => {
    A({
      type: B.RELOAD_DESIGN_SUCCESS,
      payload: D
    });
  }, W = R(
    (D, p) => {
      A({
        type: B.UPDATE_DESIGN,
        payload: {
          key: D,
          value: p
        }
      });
    },
    [L.design, E]
  ), M = R(
    (D) => {
      A({
        type: B.UPDATE_DESIGN_BASE,
        payload: D
      });
    },
    []
  ), ye = R(
    async (D) => {
      var C, h, n;
      const p = [
        "targetCohorts",
        "eventCohorts",
        "outcomeCohorts",
        "cohorts"
      ].reduce((d, m) => (D.design[m] && (d[m] = D.design[m].map((g) => ({
        versionId: g.versionId,
        ...g.alias ? { alias: g.alias } : {}
      }))), d), {});
      try {
        let d = {
          ...D.design,
          ...p
        };
        if (D.type === w.COST) {
          const g = ht(
            (C = D.design) == null ? void 0 : C.visitLength
          ), f = ((h = D.design) == null ? void 0 : h.dateRangeStart) ?? null, v = ((n = D.design) == null ? void 0 : n.dateRangeEnd) ?? null, {
            visitLength: Ee,
            dateRangeStart: ne,
            dateRangeEnd: G,
            ...q
          } = d;
          d = {
            ...q,
            dateRangeStart: f,
            dateRangeEnd: v,
            visitLength: g
          };
        }
        let m = {
          ...D,
          design: d
        };
        await S(m);
      } catch (d) {
        console.error(d);
      }
    },
    [E, L.design]
  );
  return b(() => {
    c === i.SUCCESS && (Re(a), U());
  }, [c, a]), {
    ...L,
    ...u,
    conceptSetAttr: N,
    getCountsSummary: U,
    component: _,
    parseDesign: y,
    formatDesign: O,
    atlasEntity: T,
    entity: E,
    status: c,
    draft: a,
    updateEntity: S,
    setDesign: Re,
    updateDesign: W,
    updateDesignBase: M,
    saveDesign: ye,
    reloadDesign: V,
    isEqual: se,
    outdatedCohortReferences: be,
    ...u,
    permissions: Q
  };
}, Do = (e, o = "id") => {
  let t = {};
  return e.forEach((s) => {
    t[s[o]] = s;
  }), t;
}, ho = () => K.get("/tenant/analysis-types"), mo = () => K.get("/analysis/types");
var Ne = /* @__PURE__ */ ((e) => (e.DOWNLOAD_REQUEST = "DOWNLOAD_REQUEST", e.DOWNLOAD_REQUEST_DONE = "DOWNLOAD_REQUEST_DONE", e.DOWNLOAD_REQUEST_FAILED = "DOWNLOAD_REQUEST_FAILED", e.SKIP_DOWNLOAD = "SKIP_DOWNLOAD", e))(Ne || {});
const Uo = {
  analyses: null,
  original: null,
  status: i.INITIAL,
  error: null
}, go = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case Ne.DOWNLOAD_REQUEST:
      t.analyses = null, t.status = i.IN_PROGRESS, t.error = null;
      break;
    case Ne.DOWNLOAD_REQUEST_DONE:
      t.analyses = o.payload.analyses, t.original = o.payload.original, t.status = i.SUCCESS;
      break;
    case Ne.SKIP_DOWNLOAD:
      t.status = i.SUCCESS;
      break;
    case Ne.DOWNLOAD_REQUEST_FAILED:
      t.status = i.ERROR, t.error = o.payload;
      break;
  }
}), vs = (e) => {
  const [o, t] = H(
    go,
    Uo
  ), s = async () => {
    t({
      type: Ne.DOWNLOAD_REQUEST
    });
    try {
      const r = e.preloadAnalysisTypes || (e.tenantId ? await ho() : await mo()), E = r.map((a) => a.type || a).map((a) => {
        var c;
        return (c = e.analyses) == null ? void 0 : c.find((S) => S.type === a);
      }).filter((a) => a);
      t({
        type: Ne.DOWNLOAD_REQUEST_DONE,
        payload: {
          analyses: Do(E, "type"),
          original: r
        }
      });
    } catch (r) {
      t({
        type: Ne.DOWNLOAD_REQUEST_FAILED,
        payload: r
      });
    }
  };
  return b(() => {
    s();
  }, []), {
    ...o
  };
};
var he = /* @__PURE__ */ ((e) => (e.SAVE_ANALYSIS = "SAVE_ANALYSIS", e.SAVE_ANALYSIS_DONE = "SAVE_ANALYSIS_DONE", e.SAVE_ANALYSIS_FAILED = "SAVE_ANALYSIS_FAILED", e))(he || {});
const bo = {
  status: i.INITIAL,
  entity: null
}, Po = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case he.SAVE_ANALYSIS:
      t.status = i.IN_PROGRESS;
      break;
    case he.SAVE_ANALYSIS_DONE:
      t.status = i.SUCCESS, t.entity = o.payload;
      break;
    case he.SAVE_ANALYSIS_FAILED:
      t.status = i.ERROR;
      break;
  }
}), vo = (e, o) => ({
  ...o,
  type: e.type
}), wo = (e, o, t, s) => {
  switch (t) {
    case Ke.WORKSPACE:
      return K.post(`/workspace/analyses/import/${o}`, e);
    case Ke.STUDY:
      return K.post(`/studies/${s}/analyses/import/${o}`, e);
  }
}, ws = () => {
  const [e, o] = H(Po, bo), t = R(
    async (s, r, E, a) => {
      const c = s.design ? JSON.parse(s.design) : {};
      o({
        type: he.SAVE_ANALYSIS
      });
      try {
        const S = await wo(
          (a == null ? void 0 : a.parseDesign(s, c)) || vo(s, c),
          a.url,
          r,
          E
        );
        o({
          type: he.SAVE_ANALYSIS_DONE,
          payload: S
        });
      } catch (S) {
        o({
          type: he.SAVE_ANALYSIS_FAILED,
          patload: S
        });
      }
    },
    []
  );
  return {
    ...e,
    createNewAnalysis: t
  };
}, Go = (e, o) => K.get(`/conceptset/${e}/export/${o}`), Fo = (e) => K.post(
  `conceptset/${e.conceptSetId}/included/codes`,
  e
), ko = (e) => K.get(`/analyses/${e}/export`), Tt = (e, o) => K.get(`/cohortdefinition/${e}/export/${o}`), fo = {
  exportConceptSet: null,
  exportConceptSetIds: null,
  exportConceptSetCodes: null,
  exportCohort: null,
  exportAnalysis: null,
  statusExportAnalysis: i.INITIAL,
  statusExportConceptSet: i.INITIAL,
  statusExportConceptSetIds: i.INITIAL,
  error: null
}, Yo = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case "GET_CONCEPT_SET_EXPORT_REQUEST":
      t.statusExportConceptSet = i.IN_PROGRESS;
      break;
    case "GET_CONCEPT_SET_EXPORT_DONE":
      t.statusExportConceptSet = i.SUCCESS, t.exportConceptSet = o.payload;
      break;
    case "GET_CONCEPT_SET_EXPORT_FAILED":
      t.statusExportConceptSet = i.ERROR, t.error = o.payload;
      break;
    case "GET_EXPORT_IDS_REQUEST":
      t.statusExportConceptSetIds = i.IN_PROGRESS;
      break;
    case "GET_EXPORT_IDS_DONE":
      t.statusExportConceptSetIds = i.SUCCESS, t.exportConceptSetIds = o.payload.map((s) => s == null ? void 0 : s.conceptId), t.exportConceptSetCodes = o.payload.map((s) => s == null ? void 0 : s.code);
      break;
    case "GET_EXPORT_IDS_FAILED":
      t.statusExportConceptSetIds = i.ERROR, t.error = o.payload;
      break;
    case "GET_EXPORT_ANALYSIS_REQUEST":
      t.statusExportAnalysis = i.IN_PROGRESS;
      break;
    case "GET_EXPORT_ANALYSIS_DONE":
      t.statusExportAnalysis = i.SUCCESS, t.exportAnalysis = o.payload;
      break;
    case "GET_EXPORT_ANALYSIS_FAILED":
      t.statusExportAnalysis = i.ERROR, t.error = o.payload;
      break;
    case "SAVE_EXPORT_COHORT":
      t.exportCohort = o.payload;
  }
}), Gs = (e, o, t) => {
  const [s, r] = H(Yo, fo), E = R((_) => {
    try {
      c(_), a();
    } catch (l) {
      console.error(l);
    }
  }, []), a = R(async () => {
    r({
      type: "GET_EXPORT_IDS_REQUEST"
      /* GET_EXPORT_IDS_REQUEST */
    });
    try {
      const _ = await Fo({
        conceptSetId: o
      });
      r({
        type: "GET_EXPORT_IDS_DONE",
        payload: _
      });
    } catch (_) {
      r({
        type: "GET_EXPORT_IDS_FAILED",
        payload: _
      });
    }
  }, []), c = R(async (_) => {
    r({
      type: "GET_CONCEPT_SET_EXPORT_REQUEST"
      /* GET_CONCEPT_SET_EXPORT_REQUEST */
    });
    try {
      const l = await Go(o, _);
      r({
        type: "GET_CONCEPT_SET_EXPORT_DONE",
        payload: l
      });
    } catch (l) {
      console.error(l), r({
        type: "GET_CONCEPT_SET_EXPORT_FAILED",
        payload: l
      });
    }
  }, []), S = async (_, l = "circe") => {
    var I;
    if (_)
      try {
        let T = _;
        if (l !== "prometheus")
          try {
            T = await Tt(_.id, l);
          } catch (y) {
            const O = (I = y == null ? void 0 : y.response) == null ? void 0 : I.status;
            if (!([400, 404].includes(O) && (l === "atlas" || l === "circe")))
              throw y;
            const L = l === "atlas" ? "circe" : "atlas";
            T = await Tt(_.id, L);
          }
        r({
          type: "SAVE_EXPORT_COHORT",
          payload: T
        });
      } catch (T) {
        console.error(T), r({
          type: "SAVE_EXPORT_COHORT",
          payload: _
        });
      }
  }, u = R(async () => {
    r({
      type: "GET_EXPORT_ANALYSIS_REQUEST"
      /* GET_EXPORT_ANALYSIS_REQUEST */
    });
    try {
      const _ = await ko(o);
      r({
        type: "GET_EXPORT_ANALYSIS_DONE",
        payload: _
      });
    } catch (_) {
      r({
        type: "GET_EXPORT_ANALYSIS_FAILED",
        payload: _
      });
    }
  }, []);
  return b(() => {
    switch (e) {
      case Mt.ANALYSIS:
        u();
        break;
    }
  }, [t]), {
    ...s,
    getExportConceptSet: E,
    getExportCohort: S
  };
};
var Ve = /* @__PURE__ */ ((e) => (e.LOADING_FILE = "LOADING_FILE", e.LOADED_FILE_DONE = "LOADED_FILE_DONE", e.LOADED_FILE_FAILED = "LOADED_FILE_FAILED", e))(Ve || {}), J = /* @__PURE__ */ ((e) => (e.SAVE_FILE_REQUEST = "SAVE_FILE_REQUEST", e.SAVE_FILES_REQUEST_DONE = "SAVE_FILES_REQUEST_DONE", e.SAVE_FILES_REQUEST_FAILED = "SAVE_FILES_REQUEST_FAILED", e.SELECT_FILE = "SELECT_FILE", e.LOAD_FILE_REQUEST = "LOAD_FILE_REQUEST", e.LOAD_FILE_REQUEST_DONE = "LOAD_FILE_REQUEST_DONE", e.LOAD_FILE_REQUEST_FAILED = "LOAD_FILE_REQUEST_FAILED", e))(J || {}), He = /* @__PURE__ */ ((e) => (e.FOLDER = "FOLDER", e.FILE = "FILE", e.ZIP = "ZIP", e.COMPONENT = "COMPONENT", e))(He || {});
const Vo = (e) => {
  var s;
  var o = /(?:\.([^.]+))?$/;
  const t = (s = o.exec(e)[1]) == null ? void 0 : s.toUpperCase();
  return t ? Ze[t] || Ze.UNKNOWN : "FOLDER";
}, _t = (e) => {
  const o = Object.defineProperties(
    {},
    { __size__: { value: 0, writable: !0 } }
  ), t = (s, r, E) => {
    if (s != null && s.length) {
      const a = s[0];
      r[a] || ((s == null ? void 0 : s.length) === 1 ? (r[a] = {
        ...E
      }, Object.defineProperties(r[a], {
        ext: { value: Vo(a) },
        __type__: { value: He.FILE },
        __name__: { value: a }
      })) : (r[a] = {}, Object.defineProperties(r[a], {
        ext: { value: "folder" },
        __type__: { value: He.FOLDER },
        __name__: { value: a },
        __size__: { value: 0, writable: !0 }
      })), r.__size__++), t(s.slice(1), r[a], E);
    }
  };
  return e.forEach((s) => {
    const r = s.fileMetadata.realName.split("/");
    t(r, o, s);
  }), o;
}, Mo = (e, o) => K.get(`/${o}/${e}/results/list?size=1000`), Qo = (e, o, t) => K.get(`/${t}/${e}/results/${o}/download`), xo = {
  files: null,
  hashMap: null,
  filesContent: null,
  status: i.INITIAL,
  selectedFile: void 0,
  error: null,
  fileTree: {}
}, $o = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case J.SAVE_FILE_REQUEST:
      t.status = i.IN_PROGRESS;
      break;
    case J.SAVE_FILES_REQUEST_DONE:
      t.status = i.SUCCESS, t.fileTree = o.payload.fileTree;
      break;
    case J.SAVE_FILES_REQUEST_FAILED:
      t.status = i.ERROR, t.files = o.payload;
      break;
    case J.SELECT_FILE:
      t.selectedFile === o.payload ? t.selectedFile = null : t.selectedFile = o.payload;
      break;
    case J.LOAD_FILE_REQUEST:
      t.status = Ve.LOADING_FILE;
      break;
    case J.LOAD_FILE_REQUEST_DONE:
      t.status = Ve.LOADED_FILE_DONE, t.filesContent || (t.filesContent = {}), o.payload.content && (t.filesContent[o.payload.id] = o.payload.content);
      break;
    case J.LOAD_FILE_REQUEST_FAILED:
      t.status = Ve.LOADED_FILE_FAILED, t.error = o.payload;
      break;
  }
}), Fs = (e, o, t) => {
  const [s, r] = H($o, xo), E = R(async () => {
    r({
      type: J.SAVE_FILE_REQUEST
    });
    try {
      const u = await Mo(e, o), _ = _t(u.content);
      r({
        type: J.SAVE_FILES_REQUEST_DONE,
        payload: { fileTree: _ }
      });
    } catch (u) {
      console.error(u), r({
        type: J.SAVE_FILES_REQUEST_FAILED,
        payload: u
      });
    }
  }, []), a = (u) => {
    const _ = _t(u);
    r({
      type: J.SAVE_FILES_REQUEST_DONE,
      payload: { fileTree: _ }
    });
  }, c = (u) => {
    r({
      type: J.SELECT_FILE,
      payload: u
    });
  }, S = R(
    async (u) => {
      var _;
      if (r({
        type: J.LOAD_FILE_REQUEST
      }), (_ = s.filesContent) != null && _[u])
        r({
          type: J.LOAD_FILE_REQUEST_DONE,
          payload: {
            id: u,
            content: null
          }
        });
      else
        try {
          const l = await Qo(e, u, o);
          r({
            type: J.LOAD_FILE_REQUEST_DONE,
            payload: {
              id: u,
              content: l
            }
          });
        } catch (l) {
          r({
            type: J.LOAD_FILE_REQUEST_FAILED,
            payload: l
          });
        }
    },
    [s.filesContent]
  );
  return b(() => {
    var u, _;
    (u = s.selectedFile) != null && u.id && S((_ = s.selectedFile) == null ? void 0 : _.id);
  }, [s.selectedFile]), b(() => {
    t && t.length > 0 ? a(t) : E();
  }, [t]), { ...s, selectFile: c };
}, jo = {
  storage: {},
  status: i.INITIAL
}, Bo = (e, o) => Ae(e, (t) => {
  switch (o.type) {
    case "INIT":
      t.status = i.SUCCESS, t.storage = o.payload;
      break;
    case "SET":
      t.status = i.IN_PROGRESS, t.storage = o.payload;
  }
}), ks = (e, o) => {
  const [t, s] = H(Bo, jo), r = R(
    (S) => {
      localStorage.setItem(e, JSON.stringify(t.storage));
    },
    [t.storage]
  ), E = R(() => {
    try {
      const S = localStorage.getItem(e) || JSON.stringify(o);
      s({
        type: "INIT",
        payload: JSON.parse(S || "{}")
      });
    } catch (S) {
      console.error("Problem to access local storage", S);
    }
  }, [t.storage]), a = R(
    (S, u) => {
      try {
        s({
          type: "SET",
          payload: {
            ...t.storage,
            [S]: u
          }
        });
      } catch (_) {
        console.error(`Problem to write prop ${S} to local storage`, _);
      }
    },
    [t.storage]
  ), c = R(
    (S) => {
      try {
        s({
          type: "SET",
          payload: {
            ...t.storage,
            ...S
          }
        });
      } catch (u) {
        console.error("Problem to write props to local storage", u);
      }
    },
    [t.storage]
  );
  return b(() => {
    E();
  }, []), {
    ...t,
    setProp: a,
    saveToStorage: r,
    mergeProps: c
  };
}, Ho = (e, o = "/studies/export-") => {
  const { pageNumber: t, pageSize: s, sortBy: r, query: E } = e, a = Rt(r), c = `${o}list?size=${s || ""}&page=${t || ""}&sort=${a}&${E || ""}`;
  return K.get(c);
}, Wo = 50, qo = { id: "modified.timestamp", desc: !0 }, it = (e = [], o = []) => {
  const t = [...e], s = new Set(e.map((r) => r == null ? void 0 : r.id));
  return o.forEach((r) => {
    s.has(r == null ? void 0 : r.id) || (t.push(r), s.add(r == null ? void 0 : r.id));
  }), t;
}, zo = (e, o, t = "") => {
  const s = [e].filter(Boolean);
  return o && t.trim() && s.push(
    [o, t.trim()].map(encodeURIComponent).join("=")
  ), s.join("&");
};
function fs(e, o, t = {}) {
  const {
    pageSize: s = Wo,
    sortBy: r = qo,
    query: E,
    searchFilterName: a
  } = t, [c, S] = oe([]), [u, _] = oe(i.INITIAL), [l, I] = oe(0), [T, y] = oe(1), [O, N] = oe(""), L = de(
    () => zo(E, a, O),
    [E, O, a]
  ), A = R(
    async (x = 0, Y = !1) => {
      _(i.IN_PROGRESS), !Y && S([]);
      try {
        const Q = await Ho(
          {
            pageNumber: x,
            pageSize: s,
            sortBy: r,
            query: L
          },
          e
        );
        S((se) => {
          const $ = Q.content || [];
          return it(Y ? se : o || [], $);
        }), I(x), y(Q.totalPages || 1), _(i.SUCCESS);
      } catch (Q) {
        console.error(Q), _(i.ERROR);
      }
    },
    [e, o, s, L, r]
  ), U = (x) => {
    S(x), I(0), y(1);
  }, P = R(() => {
    u === i.IN_PROGRESS || l + 1 >= T || A(l + 1, !0);
  }, [A, l, u, T]);
  return b(() => {
    o && (_(i.SUCCESS), U(o)), A(0);
  }, [A, o]), {
    list: c,
    status: u,
    setInitialList: U,
    loadMore: P,
    search: O,
    setSearch: N,
    hasMore: l + 1 < T
  };
}
const Xo = () => K.get("/domains");
function Ys() {
  const [e, o] = oe({
    status: i.INITIAL,
    domains: [],
    error: null
  }), t = R(async () => {
    try {
      const s = await Xo();
      o((r) => ({ ...r, status: i.SUCCESS, domains: s }));
    } catch (s) {
      o((r) => ({ ...r, status: i.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Jo = () => K.get("/ai/00000000-0000-0000-0000-000000000000/api/v3/filter-options");
function Vs() {
  const [e, o] = oe({
    status: i.INITIAL,
    options: null,
    error: null
  }), t = R(async () => {
    try {
      const s = await Jo(), r = {
        domains: s.domains.map((E) => ({ name: E, value: E })),
        vocabularies: s.vocabularies.map((E) => ({
          name: E,
          value: E
        })),
        standard_concepts: s.standard_concepts.map((E) => ({ name: Qt.get(E).caption, value: E })),
        concept_classes: s.concept_classes.map((E) => ({
          name: E,
          value: E
        }))
      };
      o((E) => ({ ...E, status: i.SUCCESS, options: r }));
    } catch (s) {
      o((r) => ({ ...r, status: i.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Ko = () => K.get("/ai/00000000-0000-0000-0000-000000000000/api/v3/available-models");
function Ms() {
  const [e, o] = oe({
    status: i.INITIAL,
    options: null,
    error: null
  }), t = R(async () => {
    try {
      const s = await Ko();
      o((r) => ({
        ...r,
        status: i.SUCCESS,
        options: s.availableModels.map((E) => ({
          name: E.modelName,
          value: E.modelId,
          isDefault: E.isDefault
        }))
      }));
    } catch (s) {
      o((r) => ({ ...r, status: i.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Zo = (e) => e.map((o) => ({
  ...o,
  alias: ft(o)
}));
function St(e, o = "id") {
  return e != null && e.length ? e.filter((t) => !!t).reduce(
    (t, s) => ({
      ...t,
      [s[o]]: { ...s, value: s.id }
    }),
    {}
  ) : {};
}
function Qs(e, o, t, s, r = "id", E) {
  const [a, c] = oe(
    () => St(e, r)
  ), S = (I, T) => {
    const y = s ? Zo(Array.isArray(I) ? I : [I]) : Array.isArray(I) ? I : [I];
    c((O) => {
      const N = St(y, r), L = { ...o ? O : {}, ...N };
      return t(Object.values(L)), L;
    }), T();
  }, u = async (I) => {
    const { id: T, versionId: y, currentVersionId: O } = I, N = await (E == null ? void 0 : E(T).catch(() => null));
    c((L) => {
      var U;
      const A = { ...L };
      return delete A[y], A[O] = {
        ...L[y],
        versionId: (N == null ? void 0 : N.versionId) || O,
        name: (N == null ? void 0 : N.name) || ((U = L[y]) == null ? void 0 : U.name)
      }, t(Object.values(A)), A;
    });
  }, _ = (I) => {
    c((T) => {
      const y = { ...T };
      return delete y[I], t(Object.values(y)), y;
    });
  }, l = R((I) => {
    c((T) => {
      const y = { ...T };
      return y[I[r]] = I, t(Object.values(y)), y;
    });
  }, []);
  return { state: a, updateList: S, refreshVersion: u, removeItem: _, updateItem: l };
}
function xs(e, o, t = !0) {
  const [s, r] = oe(null), [E, a] = oe(i.INITIAL), [c, S] = oe(null), u = R(
    async (..._) => {
      a(i.IN_PROGRESS);
      try {
        const l = await e(..._);
        r(l), a(i.SUCCESS);
      } catch (l) {
        console.error(l), S(l), a(i.ERROR);
      }
    },
    [e]
  );
  return b(() => {
    r(null);
  }, [e]), b(() => {
    t && u(o, {});
  }, [o, u, t]), { state: s, status: E, error: c, getData: u };
}
function $s() {
  const e = _e(null), [o, t] = oe({ width: 0, height: 0 });
  return b(() => {
    if (!e.current) return;
    const s = new ResizeObserver((r) => {
      for (let E of r) {
        const { width: a, height: c } = E.contentRect;
        t({ width: a, height: c });
      }
    });
    return s.observe(e.current), () => s.disconnect();
  }, []), [e, o];
}
const es = (e, o, t) => K.post(`/${o}/${e}/ai-generate`, t), js = (e, o, t, s) => ({ generate: R(
  async (E, a) => {
    try {
      const c = t || await e({
        name: E.title,
        studyId: o
      });
      if (!c) throw new Error("Cohort creation failed.");
      const S = es(c.id, s, E);
      return a == null || a(c), await S, c;
    } catch (c) {
      throw console.error("Error in generate function:", c), c;
    }
  },
  [e, s, t, o]
) }), ts = (e, o) => K.get("/events/ai", {
  params: e,
  signal: o
}), os = /* @__PURE__ */ new Set([
  "COHORT_AI_GENERATION_COMPLETE",
  "CONCEPTSET_AI_GENERATION_COMPLETE"
]), ss = /* @__PURE__ */ new Set(["AI_GENERATION_FAILED"]), rs = /* @__PURE__ */ new Set([
  "DONE",
  "COMPLETE",
  "COMPLETED",
  "SUCCESS",
  "SUCCEEDED",
  "FINISHED"
]), as = /* @__PURE__ */ new Set(["ERROR", "FAILED", "FAILURE"]), Le = (e) => typeof e == "string" ? e.trim().toUpperCase() : "", $e = (e) => !!(e && typeof e == "object" && typeof e.type == "string"), Ut = (e) => {
  if (Array.isArray(e))
    return e.filter($e);
  if (!e || typeof e != "object")
    return [];
  const o = e, t = ["events", "content", "items", "data", "results"];
  for (const s of t) {
    const r = o[s];
    if (Array.isArray(r))
      return r.filter($e);
  }
  return Object.values(o).filter($e);
}, Es = (e) => {
  const o = e.subject ?? {};
  return [
    Le(e.status),
    Le(o.status),
    Le(o.state),
    Le(o.aiStatus),
    Le(o.generationStatus),
    Le(o.result)
  ].filter(Boolean);
}, ns = (e) => {
  const o = Le(e.type);
  if (!o)
    return null;
  if (ss.has(o) || o.endsWith("_FAILED"))
    return "ERROR";
  if (os.has(o) || o.endsWith("_COMPLETE"))
    return "DONE";
  const t = Es(e);
  return t.some((s) => as.has(s)) ? "ERROR" : o.includes("AI_GENERATION") && t.some((s) => rs.has(s)) ? "DONE" : null;
};
function cs(e) {
  return Ut(e);
}
function ls(e) {
  const o = Ut(e);
  if (o.length === 0)
    return null;
  for (const t of o) {
    const s = ns(t);
    if (s === "ERROR")
      return "ERROR";
    if (s === "DONE")
      return "DONE";
  }
  return null;
}
function Bs() {
  const [e, o] = oe(), [t, s] = oe(null), r = _e((/* @__PURE__ */ new Date()).toISOString()), E = de(() => (/* @__PURE__ */ new Date()).toISOString(), []), a = _e(!1), c = _e(null), S = R(
    async ({ subjectId: l, signal: I }) => await ts(
      {
        rand: (/* @__PURE__ */ new Date()).toISOString(),
        since: r.current,
        ...l ? { subjectId: l } : {}
      },
      I
    ),
    [r]
  ), u = R(() => {
    var l;
    a.current = !1, (l = c.current) == null || l.abort(), c.current = null, o((I) => I === "DONE" ? "DONE" : "INITIAL");
  }, []), _ = R(
    async (l) => {
      if (a.current) return;
      r.current = (l == null ? void 0 : l.since) || (/* @__PURE__ */ new Date()).toISOString(), s(null), o("IN_PROGRESS"), a.current = !0;
      const I = new AbortController();
      c.current = I;
      try {
        for (; a.current && !I.signal.aborted; ) {
          const T = await S({
            subjectId: l == null ? void 0 : l.subjectId,
            signal: I.signal
          }), y = cs(T);
          if (y.length > 0) {
            const N = ls(y);
            if (N == "DONE") {
              a.current = !1, o("DONE"), c.current = null;
              return;
            }
            if (N == "ERROR")
              throw new Error(N);
          }
          const O = y.map((N) => N == null ? void 0 : N.timestamp).filter((N) => typeof N == "string").map((N) => Date.parse(N)).filter((N) => !Number.isNaN(N)).sort().pop();
          O && (r.current = new Date(
            Math.max(0, O - 1)
          ).toISOString());
        }
        I.signal.aborted || o("IDLE");
      } catch (T) {
        if (I.signal.aborted) return;
        s(String((T == null ? void 0 : T.message) ?? T)), o("ERROR"), a.current = !1, c.current = null;
      }
    },
    [S]
  );
  return {
    status: e,
    error: t,
    start: _,
    stop: u,
    getCurrentTimestamp: () => r.current,
    resetTimestamp: (l = E) => {
      r.current = l;
    }
  };
}
export {
  qt as DialogContext,
  As as DialogProvider,
  Nt as FILTER_PANEL_INITIAL_STATE,
  He as FileExplorerTypes,
  ee as FilterPanelActions,
  jo as INITIAL_STATE,
  eo as ModalContext,
  Os as ModalProvider,
  Cs as StudyVocabulariesContext,
  J as UseFileExplorer,
  Ve as UseFileExplorerStatus,
  X as UseMetadataValues,
  Se as UseMetadataValuesStatus,
  ge as getOverlayHistoryCount,
  dt as getOverlayHistoryState,
  Ct as pushOverlayHistoryState,
  Bo as reducer,
  Bs as useAiEventsApi,
  ws as useAnalysisImport,
  Ms as useAvailableModels,
  Ps as useDesign,
  Ys as useDomains,
  vs as useDownloadAnalysisTypes,
  $s as useElementSize,
  Is as useEntityList,
  Ro as useEntityNew,
  Gs as useExport,
  fs as useExportList,
  Fs as useFileExplorer,
  Vs as useFilterOptions,
  Rs as useFilters,
  js as useGenerate,
  hs as useInterval,
  ms as useIntervalWithCondition,
  ys as useList,
  ks as useLocalStorage,
  Us as useMetadata,
  bs as useMetadataValues,
  xs as useRequest,
  Ns as useSections,
  Ls as useSectionsNew,
  Ds as useSelectedConcepts,
  Qs as useSimpleImport,
  ds as useStudyVocabs,
  gs as useVersions
};
//# sourceMappingURL=hooks.js.map
